// Admin pages: users, license issuing/management, all machines (pool + driver approvals + legacy
// accounts) and NPC role registry. All admin-only, nav group 'admin'.
'use strict';
(function () {
  const { t, esc } = App;

  App.i18n.add({
    ko: {
      // users
      adm_users_desc: '계정을 만들고, 활성 상태를 바꾸고, 특정 사용자의 화면을 그대로 볼 수 있습니다.',
      adm_user_add: '사용자 추가', adm_user_add_title: '새 사용자',
      adm_col_user: '아이디', adm_col_role: '역할', adm_col_status: '상태',
      adm_col_licenses: '라이선스', adm_col_machines: '머신', adm_col_created: '가입', adm_col_actions: '작업',
      adm_status_active: '활성', adm_status_disabled: '비활성',
      adm_view_as: '이 사용자 화면 보기',
      adm_enable: '활성화', adm_disable: '비활성화',
      adm_enable_title: '사용자 활성화', adm_disable_title: '사용자 비활성화',
      adm_enable_msg: "'{0}' 사용자를 다시 활성화할까요?", adm_disable_msg: "'{0}' 사용자를 비활성화할까요?",
      adm_disable_detail: '비활성화하면 이 사용자는 로그인할 수 없습니다.',
      adm_user_enabled: '사용자를 활성화했습니다.', adm_user_disabled: '사용자를 비활성화했습니다.',
      adm_user_del_title: '사용자 삭제', adm_user_del_msg: "'{0}' 사용자를 삭제할까요?",
      adm_user_del_detail: '보유한 머신 {0}대·라이선스 {1}개가 함께 삭제되며 되돌릴 수 없습니다.',
      adm_user_deleted: '사용자를 삭제했습니다.', adm_user_created: '사용자를 만들었습니다.',
      adm_new_role: '역할', adm_users_empty: '등록된 사용자가 없습니다.',
      adm_name_required: '아이디를 입력하세요.', adm_pw_required: '비밀번호를 입력하세요.',
      // licenses
      adm_lic_desc: '라이선스를 발급하고 소유자·연결·회수를 관리합니다. 기간은 게임이 첫 인증에 성공하는 순간 시작됩니다.',
      adm_lic_issue: '라이선스 발급', adm_lic_issue_title: '라이선스 발급',
      adm_lic_days: '사용 기간(일)', adm_lic_count: '발급 수량', adm_lic_note: '메모(선택)', adm_lic_note_ph: '예: 11월 프로모션',
      adm_lic_issue_btn: '발급', adm_lic_issued_title: '발급 완료',
      adm_lic_issued_desc: '새 라이선스 {0}개를 발급했습니다. 키를 복사해 사용자에게 전달하세요.',
      adm_lic_copy_all: '모두 복사', adm_lic_copy_one: '이 키 복사',
      adm_lic_search_ph: '키·소유자·계정 검색', adm_lic_status_all: '모든 상태',
      adm_col_key: '키', adm_col_owner: '소유자', adm_col_slot: '바인딩 슬롯', adm_col_period: '기간 / 만료',
      adm_lic_no_owner: '소유자 없음',
      adm_lic_change_owner: '소유자 변경', adm_lic_change_owner_title: '라이선스 소유자 변경',
      adm_lic_change_owner_warn: '소유자를 바꾸면 현재 연결된 슬롯에서 자동으로 해제됩니다.',
      adm_lic_owner_label: '새 소유자', adm_lic_owner_none_opt: '소유자 없음(미지정)',
      adm_lic_owner_changed: '소유자를 변경했습니다.',
      adm_lic_unbind: '연결 해제', adm_lic_unbind_title: '슬롯 연결 해제',
      adm_lic_unbind_msg: '이 라이선스를 연결된 슬롯에서 해제할까요?',
      adm_lic_unbind_detail: '남은 기간은 유지되며 라이선스는 미사용 상태가 됩니다.',
      adm_lic_unbound: '연결을 해제했습니다.',
      adm_lic_revoke: '회수', adm_lic_revoke_title: '라이선스 회수',
      adm_lic_revoke_msg: '이 라이선스를 회수할까요?',
      adm_lic_revoke_detail: '연결된 슬롯의 실행 중인 게임이 즉시 종료되며 되돌릴 수 없습니다.',
      adm_lic_revoked: '라이선스를 회수했습니다.',
      adm_lic_empty: '발급된 라이선스가 없습니다.', adm_lic_filtered_empty: '조건에 맞는 라이선스가 없습니다.',
      adm_lic_expires: '만료 {0}', adm_lic_not_started: '미시작',
      adm_bulk_copy: '키 복사', adm_bulk_done: '{0}개 처리했습니다.',
      adm_bulk_owner_title: '선택 라이선스 소유자 변경',
      adm_bulk_unbind_msg: '선택한 {0}개 라이선스를 연결 해제할까요?',
      adm_bulk_revoke_msg: '선택한 {0}개 라이선스를 회수할까요?',
      adm_bulk_result_title: '일괄 처리 결과', adm_bulk_result_summary: '{0}개 완료 · {1}개 실패',
      adm_lic_owner_filter_ph: '아이디 검색',
      e_license_not_owned: '소유자가 아닌 라이선스입니다.', e_license_revoked: '이미 회수된 라이선스입니다.',
      e_license_expired: '만료된 라이선스입니다.', e_bad_bulk: '일괄 요청이 올바르지 않습니다.', e_bad_user: '대상 사용자가 올바르지 않습니다.',
      adm_lic_issue_owner: '소유자(선택)', adm_lic_issue_owner_none: '지정 안 함(사용자가 나중에 등록)',
      adm_lic_owner_all: '모든 소유자', adm_lic_owner_unassigned: '소유자 없음',
      adm_lic_extend: '기간 연장', adm_lic_extend_title: '라이선스 기간 연장', adm_lic_extend_days: '연장 일수',
      adm_lic_extend_detail: '시작된 라이선스는 원래 만료일부터(이미 만료됐어도) 늘어나고, 시작 전이면 사용 기간이 늘어납니다. 회수된 라이선스는 제외됩니다.',
      adm_bulk_extend_msg: '선택한 {0}개 라이선스를 연장합니다.', adm_lic_extended: '기간을 연장했습니다.',
      adm_lic_delete: '삭제', adm_lic_delete_title: '라이선스 삭제(소각)', adm_lic_delete_msg: '이 라이선스를 삭제할까요?',
      adm_bulk_delete_msg: '선택한 {0}개 라이선스를 삭제할까요?', adm_lic_delete_detail: '키가 영구히 사라지고 연결된 슬롯의 실행 중인 게임이 즉시 종료되며 되돌릴 수 없습니다.',
      adm_lic_deleted: '라이선스를 삭제했습니다.', e_bad_days: '연장 일수는 1~3650 사이 정수여야 합니다.', e_identity_exists: '대상 계정에 같은 게임 캐릭터가 이미 있습니다.',
      adm_ch_desc: '전체 사용자의 캐릭터를 보고 다른 계정으로 옮기거나 삭제합니다.',
      adm_ch_search_ph: '캐릭터·게임 계정·서버·소유자 검색', adm_ch_col_char: '캐릭터', adm_ch_col_account: '게임 계정 / 서버',
      adm_ch_col_slot: '슬롯 머신', adm_ch_col_seen: '마지막 보고', adm_ch_empty: '조건에 맞는 캐릭터가 없습니다.',
      adm_ch_transfer: '계정 이전', adm_ch_transfer_title: '캐릭터 소유자 이전',
      adm_ch_transfer_detail: '슬롯이 대상 계정의 머신이 아니면 슬롯 연결이 해제됩니다(라이선스·설정은 슬롯 소유자의 것).',
      adm_ch_transferred: '캐릭터를 이전했습니다.', adm_ch_delete_title: '캐릭터 삭제', adm_ch_delete_msg: "'{0}' 캐릭터를 삭제할까요?",
      adm_ch_delete_detail: '캐릭터 기록과 마지막 상태가 지워집니다. 다시 보고되면 그 머신 소유자의 캐릭터로 새로 만들어집니다.', adm_ch_deleted: '캐릭터를 삭제했습니다.',
      adm_wl_desc: '모든 사용자가 함께 쓰는 포털·텔레포터 NPC·주문서 목적지·통행 금지 타일입니다. 에이전트가 관측한 항목은 승인 대기로 쌓이고, 승인하면 실행 중인 에이전트에 바로 전달됩니다.',
      adm_wl_add: '이동 수단 추가', adm_wl_edit_title: '이동 수단 편집', adm_wl_edit: '편집', adm_wl_empty: '조건에 맞는 항목이 없습니다.',
      adm_wl_status_all: '모든 상태', adm_wl_status_pending: '승인 대기', adm_wl_status_active: '사용 중', adm_wl_status_disabled: '사용 안 함',
      adm_wl_kind_all: '모든 종류', adm_wl_kind_portal: '포털', adm_wl_kind_npc: '텔레포터 NPC', adm_wl_kind_scroll: '주문서 목적지', adm_wl_kind_avoid: '통행 금지',
      adm_wl_col_kind: '종류', adm_wl_col_from: '출발', adm_wl_col_to: '도착', adm_wl_col_detail: '세부', adm_wl_col_source: '출처',
      adm_wl_anywhere: '어디서나', adm_wl_push: '밀어넣기 타일', adm_wl_radius: '반경', adm_wl_adena: '아데나',
      adm_wl_source_human: '수동', adm_wl_source_agent: '에이전트 관측', adm_wl_seen_n: '관측 {0}회',
      adm_wl_approve: '승인', adm_wl_enable: '사용', adm_wl_disable: '사용 안 함', adm_wl_saved: '저장했습니다.',
      adm_wl_delete_title: '이동 수단 삭제', adm_wl_delete_msg: '이 항목을 삭제할까요? 실행 중인 에이전트에 바로 반영됩니다.', adm_wl_deleted: '삭제했습니다.',
      adm_wl_from_map: '출발 맵', adm_wl_to_map: '도착 맵', adm_wl_x: 'X', adm_wl_y: 'Y', adm_wl_push_x: '밀어넣기 X', adm_wl_push_y: '밀어넣기 Y',
      adm_wl_npc: 'NPC 이름', adm_wl_fee: '비용(아데나)', adm_wl_option: '목적지 대화 항목', adm_wl_steps: '중간 대화 항목',
      adm_wl_steps_ph: '| 로 구분. 예: 다른 지역으로 가고 싶습니다', adm_wl_scroll_item: '주문서', adm_wl_section: '구역', adm_wl_destination: '목적지',
      adm_wl_menu_layout: '메뉴 레이아웃', adm_wl_note: '메모', e_bad_world_link: '이동 수단 정보가 부족합니다.',
      // machines
      adm_mc_desc: '전체 사용자의 머신과 승인 대기 공유풀, 드라이버 승인, 레거시 계정을 관리합니다.',
      adm_mc_machines: '전체 머신', adm_mc_pool: '승인 대기 (공유풀)', adm_mc_drivers: '드라이버 승인', adm_mc_legacy: '레거시 계정',
      adm_mc_col_machine: '머신', adm_mc_col_owner: '소유자', adm_mc_col_slots: '슬롯', adm_mc_col_online: '상태',
      adm_online: '온라인', adm_offline: '오프라인',
      adm_mc_slots_n: '{0}개', adm_mc_empty: '등록된 머신이 없습니다.',
      adm_pool_empty: '대기 중인 머신이 없습니다.', adm_pool_attempts: '시도 {0}회', adm_pool_last: '마지막 {0}',
      adm_pool_dismiss: '제거', adm_pool_dismiss_title: '대기 머신 제거',
      adm_pool_dismiss_msg: '이 대기 머신을 공유풀에서 제거할까요?', adm_pool_dismissed: '공유풀에서 제거했습니다.',
      adm_drv_empty: '드라이버 승인이 없습니다.', adm_drv_revoke: '승인 취소', adm_drv_revoke_title: '드라이버 승인 취소',
      adm_drv_revoke_msg: '이 드라이버 승인을 취소할까요?',
      adm_drv_revoke_detail: '해당 PC의 드라이버 연결이 끊기고 머신이 공유풀로 돌아갑니다.',
      adm_drv_revoked: '드라이버 승인을 취소했습니다.',
      adm_legacy_empty: '연결 대기 중인 레거시 계정이 없습니다.',
      adm_legacy_desc: '예전 자동 실행용 계정입니다. 머신에 연결하면 그 머신의 슬롯으로 전환됩니다.',
      adm_legacy_attach: '머신에 연결', adm_legacy_attach_title: '머신에 연결',
      adm_legacy_attach_label: '연결할 머신',
      adm_legacy_attach_warn: '선택한 머신에 이 계정으로 새 슬롯이 만들어지고, 레거시 계정은 목록에서 사라집니다.',
      adm_legacy_attached: '머신에 연결했습니다.',
      adm_legacy_has_pw: '비밀번호 저장됨', adm_legacy_no_pw: '비밀번호 없음',
      adm_no_machines: '연결할 머신이 없습니다. 먼저 머신을 등록하세요.', adm_legacy_account: '게임 계정',
      // npc
      adm_npc_desc: '상점·창고 NPC의 역할을 게임 전역으로 지정합니다. 맵을 비우면 이름으로 탐색하는 일반 역할이 됩니다.',
      adm_npc_name: 'NPC 이름', adm_npc_name_ph: 'NPC 이름', adm_npc_role: '역할',
      adm_npc_map: '맵 ID', adm_npc_map_ph: '비우면 일반', adm_npc_region: '구역 ID', adm_npc_region_ph: '선택',
      adm_npc_add: '역할 추가', adm_npc_custom: '커스텀 역할', adm_npc_custom_empty: '커스텀 역할이 없습니다.',
      adm_npc_catalog: '자동 감지 카탈로그', adm_npc_catalog_empty: '자동 감지된 NPC가 없습니다.',
      adm_npc_use: '사용', adm_npc_general: '일반', adm_npc_map_label: '맵 {0}', adm_npc_region_label: '구역 {0}',
      adm_npc_added: '역할을 추가했습니다.', adm_npc_deleted: '역할을 삭제했습니다.',
      adm_npc_del_title: '역할 삭제', adm_npc_del_msg: "'{0}' 역할을 삭제할까요?",
      // role labels
      adm_role_misc: '잡화상인', adm_role_weapon: '무기방어구상인', adm_role_warehouse: '창고',
      adm_role_smith: '대장장이', adm_role_craft: '제작', adm_role_inn: '여관', adm_role_pet: '펫',
      adm_role_priest: '신녀', adm_role_alchemy: '연금술', adm_role_teleporter: '텔레포터',
      // platform
      adm_pf_title: '자동 실행·QA 설정',
      adm_pf_desc: '모든 머신에 공통으로 적용되는 QA DLL·접속·자동 실행 설정입니다. 저장하면 모든 머신에 바로 반영됩니다.',
      adm_pf_qa_image: 'QA DLL 이미지',
      adm_pf_qa_image_hint: '게임에 주입되는 QA DLL입니다. 새 .dll을 올리거나 기존 이미지를 선택한 뒤 저장하세요.',
      adm_pf_current_image: '현재 이미지', adm_pf_no_image: '선택된 이미지가 없습니다', adm_pf_uploaded: '{0} 업로드',
      adm_pf_upload: '.dll 업로드', adm_pf_uploading: '업로드 중…', adm_pf_uploaded_ok: '이미지를 업로드했습니다. 저장하면 적용됩니다.',
      adm_pf_upload_fail: '이미지 업로드에 실패했습니다.', adm_pf_pick_image: '기존 이미지 선택', adm_pf_pick_none: '— 이미지 선택 —',
      adm_pf_conn: '접속', adm_pf_agent_url: '에이전트 URL (WebSocket)', adm_pf_http_url: 'HTTP URL',
      adm_pf_game_image: '게임 실행 파일', adm_pf_game_image_hint: '예: LC.exe',
      adm_pf_launch_command: '게임 실행 명령', adm_pf_launch_command_hint: '게임(런처)을 실행하는 명령입니다. 예: C:\\purple\\purple.exe',
      adm_pf_qa_config: 'QA 설정 (JSON)', adm_pf_qa_config_hint: 'QA DLL에 전달되는 설정입니다. 올바른 JSON 형식이어야 저장됩니다.',
      adm_pf_json_invalid: '올바른 JSON이 아닙니다.',
      adm_pf_auto: '자동 실행', adm_pf_auto_hint: '비밀번호가 저장된 활성 슬롯을 머신당 한 번에 하나씩, 최대 클라이언트 수만큼 자동으로 실행합니다.',
      adm_pf_enabled: '자동 실행 사용',
      adm_pf_script_url: '스크립트 URL', adm_pf_script_url_hint: '실행할 스크립트를 내려받을 주소입니다.',
      adm_pf_script_path: '스크립트 경로', adm_pf_script_path_hint: 'URL 대신 로컬·저장소 경로를 쓸 때 입력합니다.',
      adm_pf_launcher: '런처 실행 명령', adm_pf_launcher_hint: '게임 런처(Purple 등)를 띄우는 명령입니다.',
      adm_pf_game_name: '게임 이름', adm_pf_game_name_hint: '런처에서 실행할 게임 항목 이름입니다.',
      adm_pf_max_clients: '머신당 최대 클라이언트', adm_pf_max_clients_hint: '한 머신에서 동시에 띄울 게임 수(1~2)입니다.',
      adm_pf_window: '실행 대기 시간(초)', adm_pf_window_hint: '게임이 뜨고 로그인까지 기다리는 시간입니다. (기본 240)',
      adm_pf_attempts: '최대 재시도 횟수', adm_pf_attempts_hint: '실패 시 다시 시도할 최대 횟수입니다. (기본 3)',
      adm_pf_cooldown: '재시도 대기 시간(초)', adm_pf_cooldown_hint: '재시도 사이에 기다리는 시간입니다. (기본 600)',
      adm_pf_dirty: '{0}곳 변경됨', adm_pf_no_changes: '변경사항 없음', adm_pf_discard: '되돌리기',
      adm_pf_saved: '저장했습니다. {0}개 머신에 반영됨', adm_pf_save_blocked: '저장하기 전에 입력 오류를 확인하세요.',
      adm_pf_default_tpl: '관리자 기본 설정(공용 프로필)',
      adm_pf_default_tpl_hint: '전용 설정도, 사용자 기본 프로필도 없는 슬롯에 적용할 공용 프로필을 선택하세요. 저장하면 해당하는 모든 슬롯에 바로 반영됩니다.',
      adm_pf_default_tpl_none: '— 지정 안 함 —',
      // machine auto-launch status
      adm_mc_col_auto: '자동 실행',
      adm_auto_driver_offline: '드라이버 오프라인', adm_auto_not_configured: '미설정', adm_auto_disabled: '사용 안 함',
      adm_auto_no_slots: '슬롯 없음', adm_auto_full: '가득 참', adm_auto_waiting_confirm: '확인 대기',
      adm_auto_launching: '실행 중', adm_auto_cooldown: '대기 중', adm_auto_idle: '대기', adm_auto_running_n: '{0}/{1} 실행',
      // migration snapshots
      adm_snap_title: '마이그레이션 스냅샷',
      adm_snap_desc: 'DB 마이그레이션 직전에 자동으로 만든 백업입니다. 문제 발생 시 복구 지점으로 사용합니다.',
      adm_snap_empty: '스냅샷이 없습니다.', adm_snap_version: '버전', adm_snap_created: '생성', adm_snap_size: '크기',
      adm_snap_copy_bookmark: '북마크 복사', adm_snap_no_bookmark: '북마크 없음', adm_snap_download: '다운로드',
      adm_snap_downloaded: '스냅샷을 내려받았습니다.', adm_snap_download_fail: '스냅샷을 내려받지 못했습니다.'
    },
    'zh-CN': {
      adm_users_desc: '创建账号、切换启用状态，并以某个用户的视角查看界面。',
      adm_user_add: '添加用户', adm_user_add_title: '新建用户',
      adm_col_user: '账号', adm_col_role: '角色', adm_col_status: '状态',
      adm_col_licenses: '授权', adm_col_machines: '机器', adm_col_created: '注册', adm_col_actions: '操作',
      adm_status_active: '启用', adm_status_disabled: '停用',
      adm_view_as: '查看该用户的界面',
      adm_enable: '启用', adm_disable: '停用',
      adm_enable_title: '启用用户', adm_disable_title: '停用用户',
      adm_enable_msg: "重新启用用户『{0}』吗？", adm_disable_msg: "停用用户『{0}』吗？",
      adm_disable_detail: '停用后该用户将无法登录。',
      adm_user_enabled: '已启用用户。', adm_user_disabled: '已停用用户。',
      adm_user_del_title: '删除用户', adm_user_del_msg: "删除用户『{0}』吗？",
      adm_user_del_detail: '其拥有的 {0} 台机器和 {1} 个授权将一并删除，且不可恢复。',
      adm_user_deleted: '已删除用户。', adm_user_created: '已创建用户。',
      adm_new_role: '角色', adm_users_empty: '暂无用户。',
      adm_name_required: '请输入账号。', adm_pw_required: '请输入密码。',
      adm_lic_desc: '发放授权并管理归属、连接与收回。有效期从游戏首次认证成功的那一刻开始计算。',
      adm_lic_issue: '发放授权', adm_lic_issue_title: '发放授权',
      adm_lic_days: '有效期（天）', adm_lic_count: '发放数量', adm_lic_note: '备注（可选）', adm_lic_note_ph: '例如：11 月促销',
      adm_lic_issue_btn: '发放', adm_lic_issued_title: '发放完成',
      adm_lic_issued_desc: '已发放 {0} 个新授权。复制密钥并发给用户。',
      adm_lic_copy_all: '全部复制', adm_lic_copy_one: '复制此密钥',
      adm_lic_search_ph: '搜索密钥·归属·账号', adm_lic_status_all: '所有状态',
      adm_col_key: '密钥', adm_col_owner: '归属', adm_col_slot: '绑定栏位', adm_col_period: '有效期 / 到期',
      adm_lic_no_owner: '无归属',
      adm_lic_change_owner: '变更归属', adm_lic_change_owner_title: '变更授权归属',
      adm_lic_change_owner_warn: '变更归属会自动从当前绑定的栏位解绑。',
      adm_lic_owner_label: '新归属', adm_lic_owner_none_opt: '无归属（未指定）',
      adm_lic_owner_changed: '已变更归属。',
      adm_lic_unbind: '解除连接', adm_lic_unbind_title: '解除栏位连接',
      adm_lic_unbind_msg: '从绑定的栏位解除此授权吗？',
      adm_lic_unbind_detail: '剩余有效期保留，授权将变为未使用状态。',
      adm_lic_unbound: '已解除连接。',
      adm_lic_revoke: '收回', adm_lic_revoke_title: '收回授权',
      adm_lic_revoke_msg: '收回此授权吗？',
      adm_lic_revoke_detail: '绑定栏位中正在运行的游戏会立即结束，且不可恢复。',
      adm_lic_revoked: '已收回授权。',
      adm_lic_empty: '暂无已发放的授权。', adm_lic_filtered_empty: '没有符合条件的授权。',
      adm_lic_expires: '到期 {0}', adm_lic_not_started: '未开始',
      adm_bulk_copy: '复制密钥', adm_bulk_done: '已处理 {0} 项。',
      adm_bulk_owner_title: '变更所选授权归属',
      adm_bulk_unbind_msg: '解除所选 {0} 个授权的连接吗？',
      adm_bulk_revoke_msg: '收回所选 {0} 个授权吗？',
      adm_bulk_result_title: '批量处理结果', adm_bulk_result_summary: '{0} 个成功 · {1} 个失败',
      adm_lic_owner_filter_ph: '搜索账号',
      e_license_not_owned: '不是归属于该用户的授权。', e_license_revoked: '授权已被收回。',
      e_license_expired: '授权已过期。', e_bad_bulk: '批量请求无效。', e_bad_user: '目标用户无效。',
      adm_lic_issue_owner: '归属账号（可选）', adm_lic_issue_owner_none: '不指定（之后由用户登记）',
      adm_lic_owner_all: '全部归属', adm_lic_owner_unassigned: '无归属',
      adm_lic_extend: '延长期限', adm_lic_extend_title: '延长授权期限', adm_lic_extend_days: '延长天数',
      adm_lic_extend_detail: '已开始的授权从原到期日起延长（已过期也一样），未开始的授权增加使用天数。已收回的授权除外。',
      adm_bulk_extend_msg: '延长所选 {0} 个授权。', adm_lic_extended: '已延长期限。',
      adm_lic_delete: '删除', adm_lic_delete_title: '删除授权（销毁）', adm_lic_delete_msg: '删除此授权吗？',
      adm_bulk_delete_msg: '删除所选 {0} 个授权吗？', adm_lic_delete_detail: '密钥将永久消失，绑定栏位中运行的游戏会立即结束，无法恢复。',
      adm_lic_deleted: '已删除授权。', e_bad_days: '延长天数须为 1~3650 的整数。', e_identity_exists: '目标账号已有同一游戏角色。',
      adm_ch_desc: '查看全部用户的角色，并转移到其他账号或删除。',
      adm_ch_search_ph: '搜索角色·游戏账号·服务器·归属', adm_ch_col_char: '角色', adm_ch_col_account: '游戏账号 / 服务器',
      adm_ch_col_slot: '栏位机器', adm_ch_col_seen: '最近上报', adm_ch_empty: '没有符合条件的角色。',
      adm_ch_transfer: '转移账号', adm_ch_transfer_title: '转移角色归属',
      adm_ch_transfer_detail: '若栏位不是目标账号的机器，将解除栏位绑定（授权与设置属于栏位所有者）。',
      adm_ch_transferred: '已转移角色。', adm_ch_delete_title: '删除角色', adm_ch_delete_msg: "删除角色 '{0}' 吗？",
      adm_ch_delete_detail: '角色记录和最后状态会被删除。再次上报时会作为该机器所有者的角色重新创建。', adm_ch_deleted: '已删除角色。',
      adm_wl_desc: '全体用户共用的传送门·传送 NPC·卷轴目的地·禁止通行地块。代理观测到的条目为待审核，审核后立即下发到运行中的代理。',
      adm_wl_add: '添加移动方式', adm_wl_edit_title: '编辑移动方式', adm_wl_edit: '编辑', adm_wl_empty: '没有符合条件的条目。',
      adm_wl_status_all: '全部状态', adm_wl_status_pending: '待审核', adm_wl_status_active: '使用中', adm_wl_status_disabled: '已停用',
      adm_wl_kind_all: '全部类型', adm_wl_kind_portal: '传送门', adm_wl_kind_npc: '传送 NPC', adm_wl_kind_scroll: '卷轴目的地', adm_wl_kind_avoid: '禁止通行',
      adm_wl_col_kind: '类型', adm_wl_col_from: '出发', adm_wl_col_to: '到达', adm_wl_col_detail: '详情', adm_wl_col_source: '来源',
      adm_wl_anywhere: '任意地点', adm_wl_push: '推入地块', adm_wl_radius: '半径', adm_wl_adena: '金币',
      adm_wl_source_human: '手动', adm_wl_source_agent: '代理观测', adm_wl_seen_n: '观测 {0} 次',
      adm_wl_approve: '审核通过', adm_wl_enable: '启用', adm_wl_disable: '停用', adm_wl_saved: '已保存。',
      adm_wl_delete_title: '删除移动方式', adm_wl_delete_msg: '删除此条目吗？运行中的代理会立即收到变更。', adm_wl_deleted: '已删除。',
      adm_wl_from_map: '出发地图', adm_wl_to_map: '到达地图', adm_wl_x: 'X', adm_wl_y: 'Y', adm_wl_push_x: '推入 X', adm_wl_push_y: '推入 Y',
      adm_wl_npc: 'NPC 名称', adm_wl_fee: '费用（金币）', adm_wl_option: '目的地对话项', adm_wl_steps: '中间对话项',
      adm_wl_steps_ph: '用 | 分隔，例如：我想去其他地区', adm_wl_scroll_item: '卷轴', adm_wl_section: '分区', adm_wl_destination: '目的地',
      adm_wl_menu_layout: '菜单布局', adm_wl_note: '备注', e_bad_world_link: '移动方式数据不完整。',
      adm_mc_desc: '管理全部用户的机器、待审核共享池、驱动审批与遗留账号。',
      adm_mc_machines: '全部机器', adm_mc_pool: '待审核（共享池）', adm_mc_drivers: '驱动审批', adm_mc_legacy: '遗留账号',
      adm_mc_col_machine: '机器', adm_mc_col_owner: '归属', adm_mc_col_slots: '栏位', adm_mc_col_online: '状态',
      adm_online: '在线', adm_offline: '离线',
      adm_mc_slots_n: '{0} 个', adm_mc_empty: '暂无机器。',
      adm_pool_empty: '没有待审核的机器。', adm_pool_attempts: '尝试 {0} 次', adm_pool_last: '最后 {0}',
      adm_pool_dismiss: '移除', adm_pool_dismiss_title: '移除待审核机器',
      adm_pool_dismiss_msg: '从共享池移除这台待审核机器吗？', adm_pool_dismissed: '已从共享池移除。',
      adm_drv_empty: '暂无驱动审批。', adm_drv_revoke: '撤销审批', adm_drv_revoke_title: '撤销驱动审批',
      adm_drv_revoke_msg: '撤销此驱动审批吗？',
      adm_drv_revoke_detail: '该 PC 的驱动连接会断开，机器将退回共享池。',
      adm_drv_revoked: '已撤销驱动审批。',
      adm_legacy_empty: '没有待连接的遗留账号。',
      adm_legacy_desc: '旧的自动运行账号。连接到机器后会转换为该机器的栏位。',
      adm_legacy_attach: '连接到机器', adm_legacy_attach_title: '连接到机器',
      adm_legacy_attach_label: '要连接的机器',
      adm_legacy_attach_warn: '会在所选机器上用此账号创建新栏位，遗留账号将从列表消失。',
      adm_legacy_attached: '已连接到机器。',
      adm_legacy_has_pw: '已保存密码', adm_legacy_no_pw: '无密码',
      adm_no_machines: '没有可连接的机器。请先注册机器。', adm_legacy_account: '游戏账号',
      adm_npc_desc: '为商店·仓库 NPC 指定游戏全局角色。地图留空则按名称查找（通用角色）。',
      adm_npc_name: 'NPC 名称', adm_npc_name_ph: 'NPC 名称', adm_npc_role: '角色',
      adm_npc_map: '地图 ID', adm_npc_map_ph: '留空=通用', adm_npc_region: '区域 ID', adm_npc_region_ph: '可选',
      adm_npc_add: '添加角色', adm_npc_custom: '自定义角色', adm_npc_custom_empty: '暂无自定义角色。',
      adm_npc_catalog: '自动检测目录', adm_npc_catalog_empty: '没有自动检测到的 NPC。',
      adm_npc_use: '使用', adm_npc_general: '通用', adm_npc_map_label: '地图 {0}', adm_npc_region_label: '区域 {0}',
      adm_npc_added: '已添加角色。', adm_npc_deleted: '已删除角色。',
      adm_npc_del_title: '删除角色', adm_npc_del_msg: "删除角色『{0}』吗？",
      adm_role_misc: '杂货商人', adm_role_weapon: '武器防具商人', adm_role_warehouse: '仓库',
      adm_role_smith: '铁匠', adm_role_craft: '制作', adm_role_inn: '旅馆', adm_role_pet: '宠物',
      adm_role_priest: '神女', adm_role_alchemy: '炼金术', adm_role_teleporter: '传送员',
      adm_pf_title: '自动运行·QA 设置',
      adm_pf_desc: '适用于所有机器的 QA DLL·连接·自动运行设置。保存后会立即应用到所有机器。',
      adm_pf_qa_image: 'QA DLL 镜像',
      adm_pf_qa_image_hint: '注入游戏的 QA DLL。上传新的 .dll 或选择现有镜像后保存。',
      adm_pf_current_image: '当前镜像', adm_pf_no_image: '未选择镜像', adm_pf_uploaded: '{0} 上传',
      adm_pf_upload: '上传 .dll', adm_pf_uploading: '上传中…', adm_pf_uploaded_ok: '镜像已上传。保存后生效。',
      adm_pf_upload_fail: '镜像上传失败。', adm_pf_pick_image: '选择现有镜像', adm_pf_pick_none: '— 选择镜像 —',
      adm_pf_conn: '连接', adm_pf_agent_url: '代理 URL (WebSocket)', adm_pf_http_url: 'HTTP URL',
      adm_pf_game_image: '游戏可执行文件', adm_pf_game_image_hint: '例如：LC.exe',
      adm_pf_launch_command: '游戏启动命令', adm_pf_launch_command_hint: '启动游戏（启动器）的命令。例如：C:\\purple\\purple.exe',
      adm_pf_qa_config: 'QA 设置 (JSON)', adm_pf_qa_config_hint: '传给 QA DLL 的设置。必须为有效 JSON 才能保存。',
      adm_pf_json_invalid: '不是有效的 JSON。',
      adm_pf_auto: '自动运行', adm_pf_auto_hint: '对已保存密码的启用栏位，每台机器一次一个、最多按最大客户端数自动运行。',
      adm_pf_enabled: '启用自动运行',
      adm_pf_script_url: '脚本 URL', adm_pf_script_url_hint: '下载要运行脚本的地址。',
      adm_pf_script_path: '脚本路径', adm_pf_script_path_hint: '不用 URL 而用本地·仓库路径时填写。',
      adm_pf_launcher: '启动器命令', adm_pf_launcher_hint: '启动游戏启动器（Purple 等）的命令。',
      adm_pf_game_name: '游戏名称', adm_pf_game_name_hint: '启动器中要运行的游戏项名称。',
      adm_pf_max_clients: '每台最大客户端', adm_pf_max_clients_hint: '一台机器同时运行的游戏数（1~2）。',
      adm_pf_window: '运行等待时间(秒)', adm_pf_window_hint: '从游戏启动到登录的等待时间。（默认 240）',
      adm_pf_attempts: '最大重试次数', adm_pf_attempts_hint: '失败时重试的最大次数。（默认 3）',
      adm_pf_cooldown: '重试等待时间(秒)', adm_pf_cooldown_hint: '两次重试之间的等待时间。（默认 600）',
      adm_pf_dirty: '{0} 处更改', adm_pf_no_changes: '没有更改', adm_pf_discard: '还原',
      adm_pf_saved: '已保存。已应用到 {0} 台机器', adm_pf_save_blocked: '保存前请检查输入错误。',
      adm_pf_default_tpl: '管理员默认设置（公共方案）',
      adm_pf_default_tpl_hint: '为既无专用设置、也无用户默认方案的栏位选择要应用的公共方案。保存后会立即应用到所有相关栏位。',
      adm_pf_default_tpl_none: '— 不指定 —',
      adm_mc_col_auto: '自动运行',
      adm_auto_driver_offline: '驱动离线', adm_auto_not_configured: '未配置', adm_auto_disabled: '未启用',
      adm_auto_no_slots: '无栏位', adm_auto_full: '已满', adm_auto_waiting_confirm: '等待确认',
      adm_auto_launching: '运行中', adm_auto_cooldown: '等待中', adm_auto_idle: '空闲', adm_auto_running_n: '{0}/{1} 运行',
      adm_snap_title: '迁移快照',
      adm_snap_desc: '数据库迁移前自动创建的备份。出现问题时作为恢复点。',
      adm_snap_empty: '暂无快照。', adm_snap_version: '版本', adm_snap_created: '创建', adm_snap_size: '大小',
      adm_snap_copy_bookmark: '复制书签', adm_snap_no_bookmark: '无书签', adm_snap_download: '下载',
      adm_snap_downloaded: '已下载快照。', adm_snap_download_fail: '下载快照失败。'
    }
  });

  (function injectCss() {
    if (document.getElementById('adm-css')) return;
    const style = document.createElement('style');
    style.id = 'adm-css';
    style.textContent = `
      .adm-keys { display: flex; flex-direction: column; gap: 6px; max-height: 50vh; overflow: auto; }
      .adm-key-row { display: flex; align-items: center; gap: 8px; }
      .adm-key-row code { flex: 1; min-width: 0; overflow-wrap: anywhere; background: var(--surface-2);
        border: 1px solid var(--border); border-radius: var(--radius); padding: 6px 10px; }
      .adm-key { font-size: 12.5px; }
      .adm-cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 12px; }
      .adm-mini { background: var(--surface-2); border: 1px solid var(--border); border-radius: var(--radius); padding: 12px;
        display: flex; flex-direction: column; gap: 8px; }
      .adm-mini .row { justify-content: space-between; }
      .adm-actions-cell { display: flex; gap: 6px; flex-wrap: wrap; }
      .pf-savebar { position: sticky; bottom: 0; z-index: 20; display: flex; align-items: center; gap: 12px;
        padding: 12px 16px; margin: 0 -24px -24px; background: var(--surface); border-top: 1px solid var(--border-strong); }
      .pf-savebar .grow { display: flex; align-items: center; gap: 8px; }
      .pf-img-current { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
      @media (max-width: 900px) { .pf-savebar { margin: 0 -16px -16px; } }`;
    document.head.appendChild(style);
  })();

  // ── small helpers ──
  const roleName = (role) => t('role_' + (role === 'admin' ? 'admin' : 'user'));

  function skeletonCard(h) { return `<div class="card skeleton" style="height:${h || 200}px"></div>`; }

  function userOptions(users, selectedId) {
    return users.map(u => `<option value="${esc(u.id)}"${Number(selectedId) === Number(u.id) ? ' selected' : ''}>${esc(u.username)}</option>`).join('');
  }

  const AUTO_TONE = { driver_offline: 'bad', not_configured: 'warn', disabled: 'neutral', no_slots: 'neutral',
    full: 'ok', waiting_confirm: 'warn', launching: 'info', cooldown: 'warn', idle: 'neutral' };
  function autoBadge(auto) {
    if (!auto) return '<span class="muted">—</span>';
    const tone = AUTO_TONE[auto.status] || 'neutral';
    const label = App.i18n.has('adm_auto_' + auto.status) ? t('adm_auto_' + auto.status) : String(auto.status || '—');
    const run = (auto.running || []).length, max = auto.max_clients != null ? auto.max_clients : '—';
    return `<span class="badge ${tone}">${esc(label)}</span>
      <div class="muted small">${esc(t('adm_auto_running_n', run, max))}${auto.detail ? ' · ' + esc(auto.detail) : ''}</div>`;
  }
  function fmtBytes(n) {
    n = Number(n) || 0;
    const u = ['B', 'KB', 'MB', 'GB']; let i = 0;
    while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
    return (i ? n.toFixed(1) : n) + ' ' + u[i];
  }

  // ════════ admin-users ════════
  App.page('admin-users', {
    admin: true, title: () => t('nav_admin_users'),
    nav: { group: 'admin', order: 10, icon: '👤' },
    async render(root) {
      root.innerHTML = `<div class="page">
        <div class="page-head">
          <div class="titles"><h1>${esc(t('nav_admin_users'))}</h1><div class="desc">${esc(t('adm_users_desc'))}</div></div>
          <div class="actions"><button class="btn primary" id="uAdd">＋ ${esc(t('adm_user_add'))}</button></div>
        </div>
        <div class="card" id="uWrap"></div>
      </div>`;
      const wrap = App.$('#uWrap', root);
      wrap.innerHTML = skeletonCard(220);

      async function load() {
        const r = await App.api('/api/admin/users');
        if (!r.ok) { wrap.innerHTML = `<div class="card-body banner error">${esc(App.errorText(r.data))}</div>`; return; }
        draw(r.data.users || []);
      }

      function draw(users) {
        if (!users.length) { wrap.innerHTML = `<div class="empty-state"><div class="empty-icon">👤</div><p>${esc(t('adm_users_empty'))}</p></div>`; return; }
        wrap.innerHTML = `<div class="table-wrap"><table class="table">
          <thead><tr>
            <th>${esc(t('adm_col_user'))}</th><th>${esc(t('adm_col_role'))}</th><th>${esc(t('adm_col_status'))}</th>
            <th>${esc(t('adm_col_licenses'))}</th><th>${esc(t('adm_col_machines'))}</th><th>${esc(t('adm_col_created'))}</th>
            <th>${esc(t('adm_col_actions'))}</th></tr></thead>
          <tbody>${users.map(u => `<tr data-id="${esc(u.id)}">
            <td><b>${esc(u.username)}</b></td>
            <td><span class="badge ${u.role === 'admin' ? 'info' : 'neutral'}">${esc(roleName(u.role))}</span></td>
            <td><span class="badge ${u.disabled ? 'bad' : 'ok'}">${esc(u.disabled ? t('adm_status_disabled') : t('adm_status_active'))}</span></td>
            <td>${esc(App.fmt.num(u.license_count))}</td>
            <td>${esc(App.fmt.num(u.machine_count))}</td>
            <td class="muted small">${esc(App.fmt.date(u.created_at))}</td>
            <td><div class="adm-actions-cell">
              <button class="btn ghost sm" data-act="view">${esc(t('adm_view_as'))}</button>
              <button class="btn ghost sm" data-act="toggle">${esc(u.disabled ? t('adm_enable') : t('adm_disable'))}</button>
              <button class="btn danger sm" data-act="del">${esc(t('delete'))}</button>
            </div></td></tr>`).join('')}</tbody></table></div>`;
        App.$$('tr[data-id]', wrap).forEach(tr => {
          const u = users.find(x => Number(x.id) === Number(tr.dataset.id));
          tr.querySelector('[data-act=view]').onclick = () => App.setViewAs({ id: u.id, username: u.username });
          tr.querySelector('[data-act=toggle]').onclick = () => toggleUser(u, load);
          tr.querySelector('[data-act=del]').onclick = () => deleteUser(u, load);
        });
      }

      App.$('#uAdd', root).onclick = () => addUserDialog(load);
      await load();
    }
  });

  function addUserDialog(done) {
    const dlg = App.dialog({
      title: t('adm_user_add_title'),
      body: `<div class="field"><label for="auName">${esc(t('username'))}</label><input id="auName" autocomplete="off" autofocus></div>
        <div class="field"><label for="auPass">${esc(t('password'))}</label><input id="auPass" type="password" autocomplete="new-password"></div>
        <div class="field"><label for="auRole">${esc(t('adm_new_role'))}</label>
          <select id="auRole"><option value="user">${esc(t('role_user'))}</option><option value="admin">${esc(t('role_admin'))}</option></select></div>
        <div class="error" id="auErr"></div>`,
      actions: [
        { label: t('cancel'), kind: 'secondary' },
        { label: t('add'), kind: 'primary', onClick: async () => {
          const username = App.$('#auName', dlg.body).value.trim();
          const password = App.$('#auPass', dlg.body).value;
          const errEl = App.$('#auErr', dlg.body);
          if (!username) { errEl.textContent = t('adm_name_required'); return false; }
          if (!password) { errEl.textContent = t('adm_pw_required'); return false; }
          const r = await App.api('/api/admin/users', { method: 'POST', body: { username, password, role: App.$('#auRole', dlg.body).value } });
          if (!r.ok) { errEl.textContent = App.errorText(r.data); return false; }
          App.toast(t('adm_user_created'));
          await done();
        } }
      ]
    });
  }

  async function toggleUser(u, done) {
    const next = !u.disabled;
    const ok = await App.confirm({
      title: next ? t('adm_disable_title') : t('adm_enable_title'),
      message: next ? t('adm_disable_msg', u.username) : t('adm_enable_msg', u.username),
      detail: next ? t('adm_disable_detail') : '',
      confirm: next ? t('adm_disable') : t('adm_enable'), danger: next
    });
    if (!ok) return;
    const r = await App.api('/api/admin/users/' + u.id + '/disable', { method: 'POST', body: { disabled: next } });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(next ? t('adm_user_disabled') : t('adm_user_enabled'));
    await done();
  }

  async function deleteUser(u, done) {
    const ok = await App.confirm({
      title: t('adm_user_del_title'), message: t('adm_user_del_msg', u.username),
      detail: t('adm_user_del_detail', Number(u.machine_count) || 0, Number(u.license_count) || 0),
      confirm: t('delete'), danger: true
    });
    if (!ok) return;
    const r = await App.api('/api/admin/users/' + u.id, { method: 'DELETE' });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_user_deleted'));
    await done();
  }

  // ════════ admin-licenses ════════
  App.page('admin-licenses', {
    admin: true, title: () => t('nav_admin_licenses'),
    nav: { group: 'admin', order: 20, icon: '🎫' },
    async render(root) {
      root.innerHTML = `<div class="page">
        <div class="page-head">
          <div class="titles"><h1>${esc(t('nav_admin_licenses'))}</h1><div class="desc">${esc(t('adm_lic_desc'))}</div></div>
          <div class="actions"><button class="btn primary" id="lIssue">＋ ${esc(t('adm_lic_issue'))}</button></div>
        </div>
        <div class="bulk-bar hidden" id="lBulk">
          <span class="count" id="lBulkCount"></span>
          <button class="btn secondary sm" data-bulk="copy">${esc(t('adm_bulk_copy'))}</button>
          <button class="btn secondary sm" data-bulk="owner">${esc(t('adm_lic_change_owner'))}</button>
          <button class="btn secondary sm" data-bulk="unbind">${esc(t('adm_lic_unbind'))}</button>
          <button class="btn secondary sm" data-bulk="extend">${esc(t('adm_lic_extend'))}</button>
          <button class="btn danger sm" data-bulk="revoke">${esc(t('adm_lic_revoke'))}</button>
          <button class="btn danger sm" data-bulk="delete">${esc(t('adm_lic_delete'))}</button>
          <span class="grow"></span>
          <button class="btn ghost sm" data-bulk="clear">${esc(t('sel_clear'))}</button>
        </div>
        <div class="toolbar">
          <input type="search" id="lSearch" placeholder="${esc(t('adm_lic_search_ph'))}" aria-label="${esc(t('adm_lic_search_ph'))}">
          <select id="lStatus" aria-label="${esc(t('adm_lic_status_all'))}">
            <option value="">${esc(t('adm_lic_status_all'))}</option>
            ${['unregistered', 'unused', 'waiting', 'active', 'expired', 'revoked'].map(s => `<option value="${s}">${esc(t('lic_' + s))}</option>`).join('')}
          </select>
          <select id="lOwner" aria-label="${esc(t('adm_lic_owner_all'))}"><option value="">${esc(t('adm_lic_owner_all'))}</option></select>
          <button class="btn ghost sm" id="lSelectAll">${esc(t('sel_all'))}</button>
          <span class="muted small grow">${esc(t('sel_hint'))}</span>
        </div>
        <div class="card" id="lWrap">${skeletonCard(260)}</div>
      </div>`;

      const wrap = App.$('#lWrap', root);
      const bulk = App.$('#lBulk', root);
      let licenses = [], users = [];
      const state = { q: '', status: '', owner: '' };
      const sel = App.selectable(wrap, { onChange: updateBulk });
      const selectedLicenses = () => { const s = new Set(sel.ids()); return licenses.filter(l => s.has(String(l.id))); };

      function updateBulk(ids) {
        const n = (ids || sel.ids()).length;
        bulk.classList.toggle('hidden', n === 0);
        App.$('#lBulkCount', bulk).textContent = t('sel_count', n);
      }

      // owner: '' all, 'none' without an owner, otherwise the exact user id.
      function matches(lic) {
        if (state.status && lic.status !== state.status) return false;
        if (state.owner === 'none' && lic.owner) return false;
        if (state.owner && state.owner !== 'none' && !(lic.owner && String(lic.owner.id) === state.owner)) return false;
        if (state.q) {
          const hay = ((lic.key || lic.key_hint || '') + ' ' + ((lic.owner && lic.owner.username) || '') + ' ' + ((lic.slot && lic.slot.game_account) || '')).toLowerCase();
          if (!hay.includes(state.q)) return false;
        }
        return true;
      }

      async function load() {
        const [lr, ur] = await Promise.all([App.api('/api/admin/licenses'), App.api('/api/admin/users')]);
        if (!lr.ok) { wrap.innerHTML = `<div class="card-body banner error">${esc(App.errorText(lr.data))}</div>`; return; }
        licenses = lr.data.licenses || [];
        users = (ur.ok && ur.data.users) || [];
        const ownerSel = App.$('#lOwner', root);
        ownerSel.innerHTML = `<option value="">${esc(t('adm_lic_owner_all'))}</option><option value="none">${esc(t('adm_lic_owner_unassigned'))}</option>` +
          userOptions(users);
        ownerSel.value = [...ownerSel.options].some(o => o.value === state.owner) ? state.owner : '';
        draw();
      }

      function draw() {
        if (!licenses.length) { wrap.innerHTML = `<div class="empty-state"><div class="empty-icon">🎫</div><p>${esc(t('adm_lic_empty'))}</p>
          <button class="btn primary" id="lEmptyIssue">＋ ${esc(t('adm_lic_issue'))}</button></div>`;
          App.$('#lEmptyIssue', wrap).onclick = () => issueDialog(load, users); sel.refresh(); return; }
        const rows = licenses.filter(matches);
        if (!rows.length) { wrap.innerHTML = `<div class="empty-state"><div class="empty-icon">🎫</div><p>${esc(t('adm_lic_filtered_empty'))}</p></div>`; sel.refresh(); return; }
        wrap.innerHTML = `<div class="table-wrap"><table class="table">
          <thead><tr>
            <th class="sel-col"><input type="checkbox" class="sel-all" aria-label="${esc(t('sel_all'))}"></th>
            <th>${esc(t('adm_col_key'))}</th><th>${esc(t('adm_col_status'))}</th><th>${esc(t('adm_col_owner'))}</th>
            <th>${esc(t('adm_col_slot'))}</th><th>${esc(t('adm_col_period'))}</th><th>${esc(t('adm_col_actions'))}</th></tr></thead>
          <tbody>${rows.map(lic => {
            const slot = lic.slot;
            const slotLabel = slot ? `${esc(slot.machine_label || slot.machine_id)} · ${esc(slot.game_account || '')}` : `<span class="muted">—</span>`;
            const expiry = lic.expires_at ? t('adm_lic_expires', App.fmt.date(lic.expires_at)) : (lic.activated_at ? '' : t('adm_lic_not_started'));
            return `<tr data-id="${esc(lic.id)}" data-sel="${esc(lic.id)}">
              <td class="sel-col"><input type="checkbox" class="sel-row" aria-label="${esc(t('sel_row'))}"></td>
              <td><div class="row nowrap"><code class="mono adm-key">${esc(lic.key || lic.key_hint)}</code>
                <button class="btn ghost sm icon" data-act="copy" title="${esc(t('adm_lic_copy_one'))}" aria-label="${esc(t('adm_lic_copy_one'))}">⧉</button></div></td>
              <td>${App.licenseBadge(lic)}</td>
              <td>${lic.owner ? esc(lic.owner.username) : `<span class="muted">${esc(t('adm_lic_no_owner'))}</span>`}</td>
              <td>${slotLabel}</td>
              <td><div>${esc(lic.duration_days != null ? t('days_n', lic.duration_days) : '—')}</div><div class="muted small">${esc(expiry)}</div></td>
              <td><div class="adm-actions-cell">
                <button class="btn ghost sm" data-act="owner">${esc(t('adm_lic_change_owner'))}</button>
                ${slot ? `<button class="btn ghost sm" data-act="unbind">${esc(t('adm_lic_unbind'))}</button>` : ''}
                ${lic.status !== 'revoked' ? `<button class="btn ghost sm" data-act="extend">${esc(t('adm_lic_extend'))}</button>` : ''}
                ${lic.status !== 'revoked' ? `<button class="btn danger sm" data-act="revoke">${esc(t('adm_lic_revoke'))}</button>` : ''}
                <button class="btn danger sm" data-act="delete">${esc(t('adm_lic_delete'))}</button>
              </div></td></tr>`;
          }).join('')}</tbody></table></div>`;
        App.$$('tr[data-id]', wrap).forEach(tr => {
          const lic = licenses.find(x => Number(x.id) === Number(tr.dataset.id));
          const copyBtn = tr.querySelector('[data-act=copy]');
          if (copyBtn) copyBtn.onclick = () => App.copy(lic.key || lic.key_hint);
          const ownerBtn = tr.querySelector('[data-act=owner]');
          if (ownerBtn) ownerBtn.onclick = () => ownerDialog(lic, users, load);
          const unbindBtn = tr.querySelector('[data-act=unbind]');
          if (unbindBtn) unbindBtn.onclick = () => unbindLicense(lic, load);
          const revokeBtn = tr.querySelector('[data-act=revoke]');
          if (revokeBtn) revokeBtn.onclick = () => revokeLicense(lic, load);
          const extendBtn = tr.querySelector('[data-act=extend]');
          if (extendBtn) extendBtn.onclick = () => extendDialog(1, async (days) => {
            const r = await App.api('/api/admin/licenses/' + lic.id + '/extend', { method: 'POST', body: { days } });
            if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return false; }
            App.toast(t('adm_lic_extended'));
            await load();
          });
          const deleteBtn = tr.querySelector('[data-act=delete]');
          if (deleteBtn) deleteBtn.onclick = () => deleteLicense(lic, load);
        });
        sel.refresh();
      }

      async function runBulk(action, user_id, days) {
        const ids = sel.ids().map(Number);
        if (!ids.length) return;
        const body = { ids, action };
        if (user_id !== undefined) body.user_id = user_id;
        if (days !== undefined) body.days = days;
        const r = await App.api('/api/admin/licenses/bulk', { method: 'POST', body });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        const failed = r.data.failed || [];
        const done = r.data.done != null ? r.data.done : (ids.length - failed.length);
        sel.clear();
        await load();
        if (failed.length) bulkResultDialog(done, failed); else App.toast(t('adm_bulk_done', done));
      }

      App.$$('[data-bulk]', bulk).forEach(b => {
        const act = b.dataset.bulk;
        b.onclick = async () => {
          const count = sel.ids().length;
          if (act === 'clear') { sel.clear(); return; }
          if (!count) return;
          if (act === 'copy') { App.copy(selectedLicenses().map(l => l.key || l.key_hint).join('\n')); return; }
          if (act === 'owner') { ownerPickerDialog({ title: t('adm_bulk_owner_title'), users, warn: true, onPick: (uid) => { runBulk('owner', uid); } }); return; }
          if (act === 'unbind') {
            const ok = await App.confirm({ title: t('adm_lic_unbind_title'), message: t('adm_bulk_unbind_msg', count), detail: t('adm_lic_unbind_detail'), confirm: t('adm_lic_unbind') });
            if (ok) runBulk('unbind');
            return;
          }
          if (act === 'extend') { extendDialog(count, (days) => { runBulk('extend', undefined, days); }); return; }
          if (act === 'revoke') {
            const ok = await App.confirm({ title: t('adm_lic_revoke_title'), message: t('adm_bulk_revoke_msg', count), detail: t('adm_lic_revoke_detail'), confirm: t('adm_lic_revoke'), danger: true });
            if (ok) runBulk('revoke');
            return;
          }
          if (act === 'delete') {
            const ok = await App.confirm({ title: t('adm_lic_delete_title'), message: t('adm_bulk_delete_msg', count), detail: t('adm_lic_delete_detail'), confirm: t('adm_lic_delete'), danger: true });
            if (ok) runBulk('delete');
          }
        };
      });
      App.$('#lSelectAll', root).onclick = () => { const h = App.$('input.sel-all', wrap); if (h && !h.checked) h.click(); };

      let deb;
      App.$('#lSearch', root).oninput = (e) => { clearTimeout(deb); deb = setTimeout(() => { state.q = e.target.value.trim().toLowerCase(); draw(); }, 200); };
      App.$('#lStatus', root).onchange = (e) => { state.status = e.target.value; draw(); };
      App.$('#lOwner', root).onchange = (e) => { state.owner = e.target.value; draw(); };
      App.$('#lIssue', root).onclick = () => issueDialog(load, users);
      await load();
      return () => sel.destroy();
    }
  });

  function issueDialog(done, users) {
    const dlg = App.dialog({
      title: t('adm_lic_issue_title'),
      body: `<div class="form-grid">
          <div class="field"><label for="liDays">${esc(t('adm_lic_days'))}</label><input id="liDays" type="number" min="1" value="30"></div>
          <div class="field"><label for="liCount">${esc(t('adm_lic_count'))}</label><input id="liCount" type="number" min="1" max="1000" value="1"></div>
          <div class="field span-all"><label for="liOwner">${esc(t('adm_lic_issue_owner'))}</label>
            <select id="liOwner"><option value="">${esc(t('adm_lic_issue_owner_none'))}</option>${userOptions(users || [])}</select></div>
          <div class="field span-all"><label for="liNote">${esc(t('adm_lic_note'))}</label><input id="liNote" placeholder="${esc(t('adm_lic_note_ph'))}"></div>
        </div><div class="error" id="liErr"></div>`,
      actions: [
        { label: t('cancel'), kind: 'secondary' },
        { label: t('adm_lic_issue_btn'), kind: 'primary', onClick: async () => {
          const duration_days = Math.max(1, Number(App.$('#liDays', dlg.body).value) || 0);
          const count = Math.max(1, Math.min(1000, Number(App.$('#liCount', dlg.body).value) || 1));
          const note = App.$('#liNote', dlg.body).value.trim();
          const owner = App.$('#liOwner', dlg.body).value;
          const r = await App.api('/api/admin/licenses/issue', { method: 'POST', body: { duration_days, count, note, user_id: owner ? Number(owner) : null } });
          if (!r.ok) { App.$('#liErr', dlg.body).textContent = App.errorText(r.data); return false; }
          await done();
          issuedKeysDialog((r.data.licenses || []).map(l => l.key).filter(Boolean));
        } }
      ]
    });
  }

  // Days to add to the selected licenses (single row or bulk); `onPick(days)`.
  function extendDialog(count, onPick) {
    const dlg = App.dialog({
      title: t('adm_lic_extend_title'),
      body: `<p>${esc(t('adm_bulk_extend_msg', count))}</p><p class="muted small">${esc(t('adm_lic_extend_detail'))}</p>
        <div class="field"><label for="leDays">${esc(t('adm_lic_extend_days'))}</label><input id="leDays" type="number" min="1" max="3650" value="30"></div>
        <div class="error" id="leErr"></div>`,
      actions: [
        { label: t('cancel'), kind: 'secondary' },
        { label: t('adm_lic_extend'), kind: 'primary', onClick: () => {
          const days = Number(App.$('#leDays', dlg.body).value);
          if (!Number.isInteger(days) || days < 1 || days > 3650) { App.$('#leErr', dlg.body).textContent = t('e_bad_days'); return false; }
          return onPick(days);
        } }
      ]
    });
  }

  function issuedKeysDialog(keys) {
    if (!keys.length) return;
    const dlg = App.dialog({
      title: t('adm_lic_issued_title'), wide: keys.length > 1,
      body: `<p>${esc(t('adm_lic_issued_desc', keys.length))}</p>
        <div class="adm-keys">${keys.map(k => `<div class="adm-key-row"><code>${esc(k)}</code>
          <button class="btn ghost sm icon" data-copy="${esc(k)}" aria-label="${esc(t('adm_lic_copy_one'))}">⧉</button></div>`).join('')}</div>`,
      actions: [
        { label: t('adm_lic_copy_all'), kind: 'secondary', onClick: () => { App.copy(keys.join('\n')); return false; } },
        { label: t('close'), kind: 'primary' }
      ]
    });
    App.$$('[data-copy]', dlg.body).forEach(b => { b.onclick = () => App.copy(b.dataset.copy); });
  }

  // Shared owner picker: a <select> of users, with a filter input when the list is long (>10).
  function ownerPickerDialog(opts) {
    const users = opts.users || [];
    const big = users.length > 10;
    const dlg = App.dialog({
      title: opts.title,
      body: `${opts.warn ? `<div class="banner warn">${esc(t('adm_lic_change_owner_warn'))}</div>` : ''}
        <div class="field"><label for="loOwner">${esc(t('adm_lic_owner_label'))}</label>
          ${big ? `<input id="loFilter" placeholder="${esc(t('adm_lic_owner_filter_ph'))}" autocomplete="off" aria-label="${esc(t('adm_lic_owner_filter_ph'))}">` : ''}
          <select id="loOwner"${big ? ' size="8"' : ''}><option value="">${esc(t('adm_lic_owner_none_opt'))}</option>${userOptions(users, opts.selectedId)}</select></div>`,
      actions: [
        { label: t('cancel'), kind: 'secondary' },
        { label: t('save'), kind: 'primary', onClick: () => { const v = App.$('#loOwner', dlg.body).value; return opts.onPick(v ? Number(v) : null); } }
      ]
    });
    const filter = App.$('#loFilter', dlg.body);
    if (filter) {
      const selEl = App.$('#loOwner', dlg.body);
      filter.oninput = () => {
        const q = filter.value.trim().toLowerCase(), cur = selEl.value;
        const ms = users.filter(u => String(u.username).toLowerCase().includes(q));
        selEl.innerHTML = `<option value="">${esc(t('adm_lic_owner_none_opt'))}</option>` + ms.map(u => `<option value="${esc(u.id)}">${esc(u.username)}</option>`).join('');
        if ([...selEl.options].some(o => o.value === cur)) selEl.value = cur;
      };
      setTimeout(() => filter.focus(), 0);
    }
    return dlg;
  }

  function ownerDialog(lic, users, done) {
    ownerPickerDialog({
      title: t('adm_lic_change_owner_title'), users, warn: true, selectedId: lic.owner && lic.owner.id,
      onPick: async (uid) => {
        const r = await App.api('/api/admin/licenses/' + lic.id + '/owner', { method: 'POST', body: { user_id: uid } });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return false; }
        App.toast(t('adm_lic_owner_changed'));
        await done();
      }
    });
  }

  function bulkResultDialog(done, failed) {
    App.dialog({
      title: t('adm_bulk_result_title'),
      body: `<p>${esc(t('adm_bulk_result_summary', done, failed.length))}</p>
        <div class="adm-keys">${failed.map(f => `<div class="adm-key-row"><code>#${esc(f.id)}</code><span class="small">${esc(App.errorText(f.err))}</span></div>`).join('')}</div>`,
      actions: [{ label: t('close'), kind: 'primary' }]
    });
  }

  async function unbindLicense(lic, done) {
    const ok = await App.confirm({ title: t('adm_lic_unbind_title'), message: t('adm_lic_unbind_msg'), detail: t('adm_lic_unbind_detail'), confirm: t('adm_lic_unbind') });
    if (!ok) return;
    const r = await App.api('/api/admin/licenses/' + lic.id + '/unbind', { method: 'POST' });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_lic_unbound'));
    await done();
  }

  async function revokeLicense(lic, done) {
    const ok = await App.confirm({ title: t('adm_lic_revoke_title'), message: t('adm_lic_revoke_msg'), detail: t('adm_lic_revoke_detail'), confirm: t('adm_lic_revoke'), danger: true });
    if (!ok) return;
    const r = await App.api('/api/admin/licenses/' + lic.id + '/revoke', { method: 'POST' });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_lic_revoked'));
    await done();
  }

  async function deleteLicense(lic, done) {
    const ok = await App.confirm({ title: t('adm_lic_delete_title'), message: t('adm_lic_delete_msg'), detail: t('adm_lic_delete_detail'), confirm: t('adm_lic_delete'), danger: true });
    if (!ok) return;
    const r = await App.api('/api/admin/licenses/' + lic.id + '/delete', { method: 'POST' });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_lic_deleted'));
    await done();
  }

  // ════════ admin-characters ════════
  App.page('admin-characters', {
    admin: true, title: () => t('nav_admin_characters'),
    nav: { group: 'admin', order: 25, icon: '🧙' },
    async render(root) {
      root.innerHTML = `<div class="page">
        <div class="page-head"><div class="titles"><h1>${esc(t('nav_admin_characters'))}</h1><div class="desc">${esc(t('adm_ch_desc'))}</div></div></div>
        <div class="toolbar">
          <input type="search" id="chSearch" placeholder="${esc(t('adm_ch_search_ph'))}" aria-label="${esc(t('adm_ch_search_ph'))}">
          <select id="chOwner" aria-label="${esc(t('adm_lic_owner_all'))}"><option value="">${esc(t('adm_lic_owner_all'))}</option></select>
        </div>
        <div class="card" id="chWrap">${skeletonCard(260)}</div>
      </div>`;
      const wrap = App.$('#chWrap', root);
      const ownerSel = App.$('#chOwner', root);
      const state = { q: '', owner: '' };
      let users = [], characters = [];

      async function load() {
        const [cr, ur] = await Promise.all([
          App.api('/api/admin/characters', { query: { q: state.q, owner: state.owner, limit: 500 } }),
          users.length ? Promise.resolve(null) : App.api('/api/admin/users')
        ]);
        if (ur && ur.ok) {
          users = ur.data.users || [];
          ownerSel.innerHTML = `<option value="">${esc(t('adm_lic_owner_all'))}</option>` + userOptions(users);
          ownerSel.value = state.owner;
        }
        if (!cr.ok) { wrap.innerHTML = `<div class="card-body banner error">${esc(App.errorText(cr.data))}</div>`; return; }
        characters = cr.data.characters || [];
        draw();
      }

      function draw() {
        if (!characters.length) { wrap.innerHTML = `<div class="empty-state"><div class="empty-icon">🧙</div><p>${esc(t('adm_ch_empty'))}</p></div>`; return; }
        wrap.innerHTML = `<div class="table-wrap"><table class="table">
          <thead><tr><th>${esc(t('adm_ch_col_char'))}</th><th>${esc(t('adm_ch_col_account'))}</th><th>${esc(t('adm_col_owner'))}</th>
            <th>${esc(t('adm_ch_col_slot'))}</th><th>${esc(t('adm_ch_col_seen'))}</th><th>${esc(t('adm_col_actions'))}</th></tr></thead>
          <tbody>${characters.map(ch => `<tr data-id="${esc(ch.id)}">
            <td><div class="row nowrap"><strong>${esc(ch.name)}</strong> <span class="badge neutral">${esc(t('dash_lv', ch.level || 0))}</span>
              <span class="badge ${ch.online ? 'ok' : 'neutral'}">${esc(t(ch.online ? 'adm_online' : 'adm_offline'))}</span></div></td>
            <td class="small">${esc(ch.game_account)}<div class="muted">${esc(ch.server_name || '—')}</div></td>
            <td>${ch.owner.username ? esc(ch.owner.username) : `<span class="muted">#${esc(ch.owner.id)}</span>`}</td>
            <td class="small">${ch.machine_label ? esc(ch.machine_label) : '<span class="muted">—</span>'}</td>
            <td class="small">${esc(App.fmt.rel(ch.last_seen_at))}</td>
            <td><div class="adm-actions-cell">
              <button class="btn ghost sm" data-act="transfer">${esc(t('adm_ch_transfer'))}</button>
              <button class="btn danger sm" data-act="delete">${esc(t('adm_lic_delete'))}</button>
            </div></td></tr>`).join('')}</tbody></table></div>`;
        App.$$('tr[data-id]', wrap).forEach(tr => {
          const ch = characters.find(x => Number(x.id) === Number(tr.dataset.id));
          tr.querySelector('[data-act=transfer]').onclick = () => transferCharacter(ch);
          tr.querySelector('[data-act=delete]').onclick = () => deleteCharacter(ch);
        });
      }

      function transferCharacter(ch) {
        const dlg = ownerPickerDialog({
          title: t('adm_ch_transfer_title'), users: users.filter(u => u.id !== ch.owner.id),
          onPick: async (uid) => {
            if (!uid) { App.toast(t('e_bad_user'), 'error'); return false; }
            const r = await App.api('/api/admin/characters/' + ch.id + '/owner', { method: 'POST', body: { user_id: uid } });
            if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return false; }
            App.toast(t('adm_ch_transferred'));
            await load();
          }
        });
        dlg.body.insertAdjacentHTML('afterbegin', `<div class="banner warn">${esc(t('adm_ch_transfer_detail'))}</div>`);
      }

      async function deleteCharacter(ch) {
        const ok = await App.confirm({ title: t('adm_ch_delete_title'), message: t('adm_ch_delete_msg', ch.name), detail: t('adm_ch_delete_detail'), confirm: t('adm_lic_delete'), danger: true });
        if (!ok) return;
        const r = await App.api('/api/admin/characters/' + ch.id, { method: 'DELETE' });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('adm_ch_deleted'));
        await load();
      }

      let deb;
      App.$('#chSearch', root).oninput = (e) => { clearTimeout(deb); deb = setTimeout(() => { state.q = e.target.value.trim(); load(); }, 250); };
      ownerSel.onchange = (e) => { state.owner = e.target.value; load(); };
      await load();
    }
  });

  // ════════ admin-world (월드 이동 등록소) ════════
  // Portals, teleporter NPCs, scroll destinations and tiles to keep off, shared by every user. Agent observations
  // arrive as pending rows; approving makes them active and pushes them to the running agents.
  const WORLD_KINDS = ['portal', 'npc', 'scroll', 'avoid'];
  // Server validation names the first missing field (400 bad_world_link); shown with the form's label.
  const WORLD_FIELD_LABELS = { kind: 'adm_wl_col_kind', status: 'adm_col_status', from_map: 'adm_wl_from_map', from_x: 'adm_wl_col_from',
    from_y: 'adm_wl_col_from', to_map: 'adm_wl_to_map', to_x: 'adm_wl_col_to', to_y: 'adm_wl_col_to', push_x: 'adm_wl_push',
    push_y: 'adm_wl_push', npc_name: 'adm_wl_npc', 'dialog.option': 'adm_wl_option', fee_adena: 'adm_wl_fee',
    scroll_item_code: 'adm_wl_scroll_item', destination: 'adm_wl_destination', radius: 'adm_wl_radius' };
  App.page('admin-world', {
    admin: true, title: () => t('nav_admin_world'),
    nav: { group: 'admin', order: 27, icon: '🗺' },
    async render(root) {
      root.innerHTML = `<div class="page">
        <div class="page-head">
          <div class="titles"><h1>${esc(t('nav_admin_world'))}</h1><div class="desc">${esc(t('adm_wl_desc'))}</div></div>
          <div class="actions"><button class="btn primary" id="wlAdd">＋ ${esc(t('adm_wl_add'))}</button></div>
        </div>
        <div class="toolbar">
          <select id="wlStatus"><option value="">${esc(t('adm_wl_status_all'))}</option>
            ${['pending', 'active', 'disabled'].map(s => `<option value="${s}">${esc(t('adm_wl_status_' + s))}</option>`).join('')}</select>
          <select id="wlKind"><option value="">${esc(t('adm_wl_kind_all'))}</option>
            ${WORLD_KINDS.map(k => `<option value="${k}">${esc(t('adm_wl_kind_' + k))}</option>`).join('')}</select>
          ${App.picker.html('map', null, { id: 'wlMap' })}
        </div>
        <div class="card" id="wlWrap">${skeletonCard(260)}</div>
      </div>`;
      const wrap = App.$('#wlWrap', root);
      const state = { status: '', kind: '', map: '' };
      let links = [];
      const where = (map, x, y) => map == null ? '—' : esc(App.cat.map(map)) + ` <span class="muted small">(${esc(x)}, ${esc(y)})</span>`;
      function detail(l) {
        if (l.kind === 'npc') return esc(l.npc_name || '') + ' · ' + esc((l.dialog && l.dialog.option) || '') +
          (l.dialog && l.dialog.steps && l.dialog.steps.length ? ` <span class="muted small">(${esc(l.dialog.steps.join(' → '))})</span>` : '') +
          (l.fee_adena ? ` · ${esc(App.fmt.num(l.fee_adena))} ${esc(t('adm_wl_adena'))}` : '');
        if (l.kind === 'scroll') return esc(App.cat.item(l.scroll_item_code)) + ' · ' + esc([l.section, l.destination].filter(Boolean).join(' / '));
        if (l.kind === 'portal') return l.push_x != null ? esc(t('adm_wl_push')) + ` (${esc(l.push_x)}, ${esc(l.push_y)})` : '';
        return esc(t('adm_wl_radius')) + ' ' + esc(l.radius || 0);
      }
      async function load() {
        const r = await App.api('/api/admin/world-links', { query: { status: state.status, kind: state.kind, map: state.map } });
        if (!r.ok) { wrap.innerHTML = `<div class="card-body banner error">${esc(App.errorText(r.data))}</div>`; return; }
        links = r.data.links || [];
        draw();
      }
      function draw() {
        if (!links.length) { wrap.innerHTML = `<div class="empty-state"><div class="empty-icon">🗺</div><p>${esc(t('adm_wl_empty'))}</p></div>`; return; }
        const tone = { pending: 'warn', active: 'ok', disabled: 'neutral' };
        wrap.innerHTML = `<div class="table-wrap"><table class="table">
          <thead><tr><th>${esc(t('adm_wl_col_kind'))}</th><th>${esc(t('adm_col_status'))}</th><th>${esc(t('adm_wl_col_from'))}</th>
            <th>${esc(t('adm_wl_col_to'))}</th><th>${esc(t('adm_wl_col_detail'))}</th><th>${esc(t('adm_wl_col_source'))}</th><th>${esc(t('adm_col_actions'))}</th></tr></thead>
          <tbody>${links.map(l => `<tr data-id="${esc(l.id)}">
            <td><span class="badge neutral">${esc(t('adm_wl_kind_' + l.kind))}</span></td>
            <td><span class="badge ${tone[l.status] || 'neutral'}">${esc(t('adm_wl_status_' + l.status))}</span></td>
            <td>${l.kind === 'scroll' ? `<span class="muted">${esc(t('adm_wl_anywhere'))}</span>` : where(l.from_map, l.from_x, l.from_y)}</td>
            <td>${l.kind === 'avoid' ? '—' : where(l.to_map, l.to_x, l.to_y)}</td>
            <td class="small">${detail(l)}${l.note ? `<div class="muted">${esc(l.note)}</div>` : ''}</td>
            <td class="small">${esc(t('adm_wl_source_' + l.source))}${l.observations ? ' · ' + esc(t('adm_wl_seen_n', l.observations)) : ''}</td>
            <td><div class="adm-actions-cell">
              ${l.status !== 'active' ? `<button class="btn secondary sm" data-act="active">${esc(t(l.status === 'pending' ? 'adm_wl_approve' : 'adm_wl_enable'))}</button>` : ''}
              ${l.status === 'active' ? `<button class="btn ghost sm" data-act="disabled">${esc(t('adm_wl_disable'))}</button>` : ''}
              <button class="btn ghost sm" data-act="edit">${esc(t('adm_wl_edit'))}</button>
              <button class="btn danger sm" data-act="delete">${esc(t('adm_lic_delete'))}</button>
            </div></td></tr>`).join('')}</tbody></table></div>`;
        App.$$('tr[data-id]', wrap).forEach(tr => {
          const link = links.find(x => Number(x.id) === Number(tr.dataset.id));
          tr.querySelectorAll('[data-act=active],[data-act=disabled]').forEach(b => { b.onclick = () => setStatus(link, b.dataset.act); });
          tr.querySelector('[data-act=edit]').onclick = () => editDialog(link);
          tr.querySelector('[data-act=delete]').onclick = () => removeLink(link);
        });
      }
      async function setStatus(link, status) {
        const r = await App.api('/api/admin/world-links/' + link.id, { method: 'PUT', body: { status } });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('adm_wl_saved'));
        await load();
      }
      async function removeLink(link) {
        const ok = await App.confirm({ title: t('adm_wl_delete_title'), message: t('adm_wl_delete_msg'), confirm: t('adm_lic_delete'), danger: true });
        if (!ok) return;
        const r = await App.api('/api/admin/world-links/' + link.id, { method: 'DELETE' });
        if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
        App.toast(t('adm_wl_deleted'));
        await load();
      }
      // One form for every kind; the fields a kind does not use are hidden and dropped by the server.
      function editDialog(link) {
        const l = link || { kind: 'portal', status: 'active' };
        const num = (id, label, value) => `<div class="field"><label for="${id}">${esc(t(label))}</label><input id="${id}" type="number" value="${value == null ? '' : esc(value)}"></div>`;
        const txt = (id, label, value, ph) => `<div class="field span-all"><label for="${id}">${esc(t(label))}</label><input id="${id}" value="${value == null ? '' : esc(value)}"${ph ? ` placeholder="${esc(ph)}"` : ''}></div>`;
        const pick = (id, kind, label, value) => `<div class="field"><label>${esc(t(label))}</label>${App.picker.html(kind, value, { id })}</div>`;
        const dlg = App.dialog({
          title: t(link ? 'adm_wl_edit_title' : 'adm_wl_add'), wide: true,
          body: `<div class="form-grid">
              <div class="field"><label for="wfKind">${esc(t('adm_wl_col_kind'))}</label><select id="wfKind">${WORLD_KINDS.map(k => `<option value="${k}"${k === l.kind ? ' selected' : ''}>${esc(t('adm_wl_kind_' + k))}</option>`).join('')}</select></div>
              <div class="field"><label for="wfStatus">${esc(t('adm_col_status'))}</label><select id="wfStatus">${['active', 'pending', 'disabled'].map(s => `<option value="${s}"${s === l.status ? ' selected' : ''}>${esc(t('adm_wl_status_' + s))}</option>`).join('')}</select></div>
              <div class="wf-group span-all" data-for="portal npc avoid"><div class="form-grid">
                ${pick('wfFromMap', 'map', 'adm_wl_from_map', l.from_map)}${num('wfFromX', 'adm_wl_x', l.from_x)}${num('wfFromY', 'adm_wl_y', l.from_y)}</div></div>
              <div class="wf-group span-all" data-for="avoid">${num('wfRadius', 'adm_wl_radius', l.radius)}</div>
              <div class="wf-group span-all" data-for="portal npc scroll"><div class="form-grid">
                ${pick('wfToMap', 'map', 'adm_wl_to_map', l.to_map)}${num('wfToX', 'adm_wl_x', l.to_x)}${num('wfToY', 'adm_wl_y', l.to_y)}</div></div>
              <div class="wf-group span-all" data-for="portal"><div class="form-grid">${num('wfPushX', 'adm_wl_push_x', l.push_x)}${num('wfPushY', 'adm_wl_push_y', l.push_y)}</div></div>
              <div class="wf-group span-all" data-for="npc"><div class="form-grid">
                ${pick('wfNpc', 'npc', 'adm_wl_npc', l.npc_name)}${num('wfFee', 'adm_wl_fee', l.fee_adena)}
                ${txt('wfOption', 'adm_wl_option', l.dialog && l.dialog.option)}
                ${txt('wfSteps', 'adm_wl_steps', l.dialog && l.dialog.steps && l.dialog.steps.join(' | '), t('adm_wl_steps_ph'))}</div></div>
              <div class="wf-group span-all" data-for="scroll"><div class="form-grid">
                ${pick('wfItem', 'item', 'adm_wl_scroll_item', l.scroll_item_code)}
                ${txt('wfSection', 'adm_wl_section', l.section)}${txt('wfDestination', 'adm_wl_destination', l.destination)}
                ${txt('wfLayout', 'adm_wl_menu_layout', l.menu_layout, 'TalkingScrollLayout')}</div></div>
              ${txt('wfNote', 'adm_wl_note', l.note)}
            </div><div class="error" id="wfErr"></div>`,
          actions: [
            { label: t('cancel'), kind: 'secondary' },
            { label: t('save'), kind: 'primary', onClick: async () => {
              const $v = (id) => App.$('#' + id, dlg.body).value.trim();
              const n = (id) => $v(id) === '' ? null : Number($v(id));
              const p = (id) => { const v = App.picker.read(App.$('#' + id, dlg.body)); return v == null ? null : v; };
              const body = { kind: $v('wfKind'), status: $v('wfStatus'), from_map: p('wfFromMap'), from_x: n('wfFromX'), from_y: n('wfFromY'),
                radius: n('wfRadius'), to_map: p('wfToMap'), to_x: n('wfToX'), to_y: n('wfToY'), push_x: n('wfPushX'), push_y: n('wfPushY'),
                npc_name: p('wfNpc'), fee_adena: n('wfFee'), scroll_item_code: p('wfItem'), section: $v('wfSection'),
                destination: $v('wfDestination'), menu_layout: $v('wfLayout'), note: $v('wfNote') };
              if (body.kind === 'npc') body.dialog = { option: $v('wfOption'), steps: $v('wfSteps').split('|').map(s => s.trim()).filter(Boolean) };
              const r = link ? await App.api('/api/admin/world-links/' + link.id, { method: 'PUT', body })
                : await App.api('/api/admin/world-links', { method: 'POST', body });
              if (!r.ok) {
                const field = r.data && WORLD_FIELD_LABELS[r.data.field];
                App.$('#wfErr', dlg.body).textContent = App.errorText(r.data) + (field ? ' (' + t(field) + ')' : '');
                return false;
              }
              App.toast(t('adm_wl_saved'));
              await load();
            } }
          ]
        });
        const unbind = App.picker.bind(dlg.body, {});
        const kindSel = App.$('#wfKind', dlg.body);
        const sync = () => App.$$('.wf-group', dlg.body).forEach(g => { g.hidden = !g.dataset.for.split(' ').includes(kindSel.value); });
        kindSel.onchange = sync; sync();
        return { dlg, unbind };
      }
      const unbindFilter = App.picker.bind(root, { onSelect: (pick, value) => { state.map = value == null ? '' : String(value); load(); },
        onType: (pick) => { if (!pick.querySelector('.pick-in').value) { state.map = ''; load(); } } });
      App.$('#wlStatus', root).onchange = (e) => { state.status = e.target.value; load(); };
      App.$('#wlKind', root).onchange = (e) => { state.kind = e.target.value; load(); };
      App.$('#wlAdd', root).onclick = () => editDialog(null);
      await load();
      return () => { if (unbindFilter) unbindFilter(); };
    }
  });

  // ════════ admin-machines ════════
  App.page('admin-machines', {
    admin: true, title: () => t('nav_admin_machines'),
    nav: { group: 'admin', order: 30, icon: '🗄' },
    async render(root) {
      root.innerHTML = `<div class="page">
        <div class="page-head"><div class="titles"><h1>${esc(t('nav_admin_machines'))}</h1><div class="desc">${esc(t('adm_mc_desc'))}</div></div></div>
        <div id="mcContent">${skeletonCard(320)}</div>
      </div>`;
      const content = App.$('#mcContent', root);
      let data = {};

      async function load() {
        const r = await App.api('/api/admin/machines');
        if (!r.ok) { content.innerHTML = `<div class="banner error">${esc(App.errorText(r.data))}</div>`; return; }
        data = r.data || {};
        draw();
      }

      function draw() {
        const machines = data.machines || [], pool = data.pool || [], drivers = data.drivers || [], legacy = data.legacy_accounts || [];
        content.innerHTML = `
          <section class="section"><div class="section-head"><h2>${esc(t('adm_mc_machines'))}</h2></div>
            <div class="card">${machines.length ? `<div class="table-wrap"><table class="table">
              <thead><tr><th>${esc(t('adm_mc_col_machine'))}</th><th>${esc(t('adm_mc_col_owner'))}</th><th>${esc(t('adm_mc_col_slots'))}</th><th>${esc(t('adm_mc_col_online'))}</th><th>${esc(t('adm_mc_col_auto'))}</th></tr></thead>
              <tbody>${machines.map(m => `<tr>
                <td><b>${esc(m.label)}</b>${m.hostname ? `<div class="muted small">${esc(m.hostname)}</div>` : ''}</td>
                <td>${m.owner ? esc(m.owner.username) : '<span class="muted">—</span>'}</td>
                <td>${esc(t('adm_mc_slots_n', (m.slots || []).length))}</td>
                <td><span class="badge ${m.online ? 'ok' : 'neutral'}"><span class="dot ${m.online ? 'ok' : ''}"></span>${esc(m.online ? t('adm_online') : t('adm_offline'))}</span></td>
                <td>${autoBadge(m.auto)}</td>
              </tr>`).join('')}</tbody></table></div>`
              : `<div class="empty-state"><div class="empty-icon">🗄</div><p>${esc(t('adm_mc_empty'))}</p></div>`}</div>
          </section>

          <section class="section"><div class="section-head"><h2>${esc(t('adm_mc_pool'))}</h2><span class="badge neutral">${pool.length}</span></div>
            <div class="card">${pool.length ? `<div class="card-body adm-cards">${pool.map((p, i) => `<div class="adm-mini" data-pool="${i}">
              <div class="row"><code class="mono truncate">${esc(p.pc_hash)}</code></div>
              <div class="muted small">${esc(t('adm_pool_attempts', p.attempts || 0))} · ${esc(t('adm_pool_last', App.fmt.rel(p.last_seen)))}</div>
              <div><button class="btn danger sm" data-act="dismiss">${esc(t('adm_pool_dismiss'))}</button></div></div>`).join('')}</div>`
              : `<div class="empty-state"><p>${esc(t('adm_pool_empty'))}</p></div>`}</div>
          </section>

          <section class="section"><div class="section-head"><h2>${esc(t('adm_mc_drivers'))}</h2><span class="badge neutral">${drivers.length}</span></div>
            <div class="card">${drivers.length ? `<div class="table-wrap"><table class="table">
              <thead><tr><th>PC</th><th>${esc(t('adm_col_status'))}</th><th>${esc(t('adm_col_period'))}</th><th></th></tr></thead>
              <tbody>${drivers.map(d => `<tr data-drv="${esc(d.id)}">
                <td><code class="mono">${esc(d.pc_hash)}</code>${d.note ? `<div class="muted small">${esc(d.note)}</div>` : ''}</td>
                <td><span class="badge info">${esc(d.state)}</span></td>
                <td class="muted small">${esc(d.expires_at ? App.fmt.date(d.expires_at) : '—')}</td>
                <td class="right"><button class="btn danger sm" data-act="drv-revoke">${esc(t('adm_drv_revoke'))}</button></td>
              </tr>`).join('')}</tbody></table></div>`
              : `<div class="empty-state"><p>${esc(t('adm_drv_empty'))}</p></div>`}</div>
          </section>

          <section class="section"><div class="section-head"><h2>${esc(t('adm_mc_legacy'))}</h2><span class="badge neutral">${legacy.length}</span>
            <span class="desc">${esc(t('adm_legacy_desc'))}</span></div>
            <div class="card">${legacy.length ? `<div class="card-body adm-cards">${legacy.map(a => `<div class="adm-mini" data-legacy="${esc(a.id)}">
              <div class="row between nowrap"><b class="truncate">${esc(a.game_account)}</b>
                <span class="badge ${a.has_password ? 'ok' : 'neutral'}">${esc(a.has_password ? t('adm_legacy_has_pw') : t('adm_legacy_no_pw'))}</span></div>
              <div class="muted small">${a.machine ? '🖥 ' + esc(a.machine) + ' · ' : ''}${esc(App.fmt.rel(a.last_seen))}</div>
              ${a.note ? `<div class="muted small">${esc(a.note)}</div>` : ''}
              <div><button class="btn secondary sm" data-act="attach">${esc(t('adm_legacy_attach'))}</button></div></div>`).join('')}</div>`
              : `<div class="empty-state"><p>${esc(t('adm_legacy_empty'))}</p></div>`}</div>
          </section>`;

        App.$$('[data-pool]', content).forEach(el => {
          const p = pool[Number(el.dataset.pool)];
          el.querySelector('[data-act=dismiss]').onclick = () => dismissPool(p, load);
        });
        App.$$('[data-drv]', content).forEach(tr => {
          const d = drivers.find(x => Number(x.id) === Number(tr.dataset.drv));
          tr.querySelector('[data-act=drv-revoke]').onclick = () => revokeDriver(d, load);
        });
        App.$$('[data-legacy]', content).forEach(el => {
          const a = legacy.find(x => Number(x.id) === Number(el.dataset.legacy));
          el.querySelector('[data-act=attach]').onclick = () => attachLegacy(a, machines, load);
        });
      }

      await load();
    }
  });

  async function dismissPool(p, done) {
    const ok = await App.confirm({ title: t('adm_pool_dismiss_title'), message: t('adm_pool_dismiss_msg'), confirm: t('adm_pool_dismiss'), danger: true });
    if (!ok) return;
    const r = await App.api('/api/machine-pool/dismiss', { method: 'POST', body: { pc_hash: p.pc_hash } });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_pool_dismissed'));
    await done();
  }

  async function revokeDriver(d, done) {
    const ok = await App.confirm({ title: t('adm_drv_revoke_title'), message: t('adm_drv_revoke_msg'), detail: t('adm_drv_revoke_detail'), confirm: t('adm_drv_revoke'), danger: true });
    if (!ok) return;
    const r = await App.api('/api/admin/component-licenses/' + d.id + '/revoke', { method: 'POST' });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_drv_revoked'));
    await done();
  }

  function attachLegacy(a, machines, done) {
    if (!machines.length) { App.toast(t('adm_no_machines'), 'error'); return; }
    const dlg = App.dialog({
      title: t('adm_legacy_attach_title'),
      body: `<div class="banner info">${esc(t('adm_legacy_attach_warn'))}</div>
        <div class="kv"><div><span class="k">${esc(t('adm_legacy_account'))}</span><div class="v mono">${esc(a.game_account)}</div></div></div>
        <div class="field"><label for="laMachine">${esc(t('adm_legacy_attach_label'))}</label>
          <select id="laMachine">${machines.map(m => `<option value="${esc(m.id)}">${esc(m.label)}${m.owner ? ' · ' + esc(m.owner.username) : ''}</option>`).join('')}</select></div>`,
      actions: [
        { label: t('cancel'), kind: 'secondary' },
        { label: t('adm_legacy_attach'), kind: 'primary', onClick: async () => {
          const machine_id = Number(App.$('#laMachine', dlg.body).value);
          const r = await App.api('/api/admin/legacy-accounts/' + a.id + '/attach', { method: 'POST', body: { machine_id } });
          if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return false; }
          App.toast(t('adm_legacy_attached'));
          await done();
        } }
      ]
    });
  }

  // ════════ admin-npc ════════
  const NPC_ROLES = [
    ['잡화상인', 'adm_role_misc'], ['무기방어구상인', 'adm_role_weapon'], ['창고', 'adm_role_warehouse'],
    ['대장장이', 'adm_role_smith'], ['제작', 'adm_role_craft'], ['여관', 'adm_role_inn'], ['펫', 'adm_role_pet'],
    ['신녀', 'adm_role_priest'], ['연금술', 'adm_role_alchemy'], ['텔레포터', 'adm_role_teleporter']
  ];
  const roleLabel = (role) => { const found = NPC_ROLES.find(([v]) => v === role); return found ? t(found[1]) : String(role); };
  const npcScope = (r) => (r.map_id != null && r.map_id !== '' ? t('adm_npc_map_label', r.map_id) : t('adm_npc_general'))
    + ((r.region_id != null && r.region_id !== '') ? ' · ' + t('adm_npc_region_label', r.region_id) : '');

  App.page('admin-npc', {
    admin: true, title: () => t('nav_admin_npc'),
    nav: { group: 'admin', order: 40, icon: '🧙' },
    async render(root) {
      root.innerHTML = `<div class="page">
        <div class="page-head"><div class="titles"><h1>${esc(t('nav_admin_npc'))}</h1><div class="desc">${esc(t('adm_npc_desc'))}</div></div></div>
        <section class="section"><div class="card"><div class="card-body">
          <div class="form-grid">
            <div class="field"><label>${esc(t('adm_npc_name'))}</label>${App.picker.html('npc', '', { id: 'npNamePick' })}</div>
            <div class="field"><label for="npRole">${esc(t('adm_npc_role'))}</label><select id="npRole">${NPC_ROLES.map(([v, k]) => `<option value="${esc(v)}">${esc(t(k))}</option>`).join('')}</select></div>
            <div class="field"><label>${esc(t('adm_npc_map'))}</label>${App.picker.html('map', '', { id: 'npMapPick' })}</div>
            <div class="field"><label>${esc(t('adm_npc_region'))}</label>${App.picker.html('region', '', { id: 'npRegionPick' })}</div>
          </div></div>
          <div class="card-foot"><button class="btn primary" id="npAdd">＋ ${esc(t('adm_npc_add'))}</button></div></div>
        </section>
        <section class="section"><div class="section-head"><h2>${esc(t('adm_npc_custom'))}</h2><span class="badge neutral" id="npCustCount">0</span></div>
          <div id="npCustom">${skeletonCard(120)}</div></section>
        <section class="section"><div class="section-head"><h2>${esc(t('adm_npc_catalog'))}</h2></div>
          <div id="npCatalog"></div></section>
      </div>`;

      const customEl = App.$('#npCustom', root);
      const catalogEl = App.$('#npCatalog', root);

      async function loadCustom() {
        const r = await App.api('/api/admin/npc-roles');
        const custom = (r.ok && r.data.custom) || [];
        App.$('#npCustCount', root).textContent = String(custom.length);
        if (!custom.length) { customEl.innerHTML = `<div class="card"><div class="empty-state"><p>${esc(t('adm_npc_custom_empty'))}</p></div></div>`; return; }
        customEl.innerHTML = `<div class="card"><div class="card-body adm-cards">${custom.map(r2 => `<div class="adm-mini" data-npc="${esc(r2.id)}">
          <div class="row between nowrap"><b class="truncate">${esc(r2.npc_name)}</b><span class="badge info">${esc(roleLabel(r2.role))}</span></div>
          <div class="muted small">${esc(npcScope(r2))}</div>
          <div><button class="btn danger sm" data-act="del">${esc(t('delete'))}</button></div></div>`).join('')}</div></div>`;
        App.$$('[data-npc]', customEl).forEach(el => {
          const r2 = custom.find(x => Number(x.id) === Number(el.dataset.npc));
          el.querySelector('[data-act=del]').onclick = () => deleteNpc(r2, loadCustom);
        });
      }

      function drawCatalog() {
        const cat = ((App.catalog && App.catalog.npc_roles) || {}).roles || [];
        if (!cat.length) { catalogEl.innerHTML = `<div class="card"><div class="empty-state"><p>${esc(t('adm_npc_catalog_empty'))}</p></div></div>`; return; }
        catalogEl.innerHTML = `<div class="card"><div class="card-body adm-cards">${cat.map((r2, i) => `<div class="adm-mini" data-cat="${i}">
          <div class="row between nowrap"><b class="truncate">${esc(r2.name)}</b><span class="badge neutral">${esc(roleLabel(r2.role))}</span></div>
          <div class="muted small">${esc(t('adm_npc_map_label', r2.map))}${r2.region != null ? ' · ' + esc(t('adm_npc_region_label', r2.region)) : ''}</div>
          <div><button class="btn secondary sm" data-act="use">${esc(t('adm_npc_use'))}</button></div></div>`).join('')}</div></div>`;
        App.$$('[data-cat]', catalogEl).forEach(el => {
          const r2 = cat[Number(el.dataset.cat)];
          el.querySelector('[data-act=use]').onclick = () => addNpc({ npc_name: r2.name, role: r2.role, map_id: r2.map, region_id: r2.region }, loadCustom);
        });
      }

      App.$('#npAdd', root).onclick = async () => {
        const nameP = App.$('#npNamePick', root), mapP = App.$('#npMapPick', root), regionP = App.$('#npRegionPick', root);
        const name = App.picker.read(nameP);
        if (!name) { App.toast(t('adm_name_required'), 'error'); return; }
        const map = App.picker.read(mapP), region = App.picker.read(regionP);
        await addNpc({ npc_name: String(name), role: App.$('#npRole', root).value, map_id: map == null ? null : Number(map), region_id: region == null ? null : Number(region) }, () => {
          App.picker.set(nameP, ''); App.picker.set(mapP, ''); App.picker.set(regionP, '');
          return loadCustom();
        });
      };

      const unbindPickers = App.picker.bind(root);
      drawCatalog();
      await loadCustom();
      return () => unbindPickers();
    }
  });

  async function addNpc(body, done) {
    const r = await App.api('/api/admin/npc-roles', { method: 'POST', body });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_npc_added'));
    await done();
  }

  async function deleteNpc(r2, done) {
    const ok = await App.confirm({ title: t('adm_npc_del_title'), message: t('adm_npc_del_msg', r2.npc_name), confirm: t('delete'), danger: true });
    if (!ok) return;
    const r = await App.api('/api/admin/npc-roles/' + r2.id, { method: 'DELETE' });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('adm_npc_deleted'));
    await done();
  }

  // ════════ admin-platform (auto-launch + QA settings) ════════
  App.page('admin-platform', {
    admin: true, title: () => t('adm_pf_title'),
    nav: { group: 'admin', order: 35, icon: '⚙' },
    async render(root) {
      root.innerHTML = `<div class="page">${skeletonCard(420)}</div>`;
      const r = await App.api('/api/admin/platform');
      if (!r.ok) { root.innerHTML = `<div class="page"><div class="banner error">${esc(App.errorText(r.data))}</div></div>`; return; }
      let platform = r.data.platform || {};
      let images = r.data.images || [];
      let imageSha = platform.qa_image_sha256 || '';
      let orig = {}, origPretty = '{}';

      const shortSha = (s) => s ? String(s).slice(0, 12) : '';
      const imageOptions = () => `<option value="">${esc(t('adm_pf_pick_none'))}</option>` + images.map(im =>
        `<option value="${esc(im.sha256)}">${esc(shortSha(im.sha256))} · ${esc(App.fmt.date(im.uploaded_at))} · ${esc(fmtBytes(im.size))}</option>`).join('');
      let sharedTpls = [];
      { const tr = await App.api('/api/templates'); if (tr.ok) sharedTpls = (tr.data.templates || []).filter(x => x.shared); }
      const defaultTplOptions = () => `<option value="">${esc(t('adm_pf_default_tpl_none'))}</option>` +
        sharedTpls.map(tp => `<option value="${esc(tp.id)}">${esc(tp.name)}${tp.owner ? ' (' + esc(tp.owner) + ')' : ''}</option>`).join('');

      root.innerHTML = `<div class="page">
        <div class="page-head"><div class="titles"><h1>${esc(t('adm_pf_title'))}</h1><div class="desc">${esc(t('adm_pf_desc'))}</div></div></div>
        <div id="pfForm" class="stack">
          <section class="section"><div class="section-head"><h2>${esc(t('adm_pf_qa_image'))}</h2><span class="desc">${esc(t('adm_pf_qa_image_hint'))}</span></div>
            <div class="card"><div class="card-body stack">
              <div class="pf-img-current"><span class="muted small">${esc(t('adm_pf_current_image'))}:</span>
                <code class="mono" id="pfImgSha"></code><span class="muted small" id="pfImgMeta"></span></div>
              <div class="row">
                <label class="btn secondary sm" id="pfUploadBtn"><input type="file" id="pfFile" accept=".dll,application/octet-stream" hidden><span id="pfUploadLabel">⬆ ${esc(t('adm_pf_upload'))}</span></label>
                <select id="pfPick" class="grow" style="max-width:460px" aria-label="${esc(t('adm_pf_pick_image'))}">${imageOptions()}</select>
              </div>
            </div></div>
          </section>
          <section class="section"><div class="section-head"><h2>${esc(t('adm_pf_conn'))}</h2></div>
            <div class="card"><div class="card-body"><div class="form-grid">
              <div class="field span-all"><label for="pfAgentUrl">${esc(t('adm_pf_agent_url'))}</label><input id="pfAgentUrl" class="mono"></div>
              <div class="field span-all"><label for="pfHttpUrl">${esc(t('adm_pf_http_url'))}</label><input id="pfHttpUrl" class="mono"></div>
              <div class="field"><label for="pfGameImage">${esc(t('adm_pf_game_image'))}</label><input id="pfGameImage"><div class="hint">${esc(t('adm_pf_game_image_hint'))}</div></div>
              <div class="field span-all"><label for="pfLaunchCmd">${esc(t('adm_pf_launch_command'))}</label><input id="pfLaunchCmd" class="mono"><div class="hint">${esc(t('adm_pf_launch_command_hint'))}</div></div>
            </div></div></div>
          </section>
          <section class="section"><div class="section-head"><h2>${esc(t('adm_pf_default_tpl'))}</h2><span class="desc">${esc(t('adm_pf_default_tpl_hint'))}</span></div>
            <div class="card"><div class="card-body"><div class="field">
              <select id="pfDefaultTpl" style="max-width:460px"></select>
            </div></div></div>
          </section>
          <section class="section"><div class="section-head"><h2>${esc(t('adm_pf_qa_config'))}</h2><span class="desc">${esc(t('adm_pf_qa_config_hint'))}</span></div>
            <div class="card"><div class="card-body"><div class="field" id="pfQaField">
              <textarea id="pfQaConfig" rows="10" spellcheck="false" style="min-height:200px"></textarea>
              <div class="error" id="pfQaErr"></div>
            </div></div></div>
          </section>
          <section class="section"><div class="section-head"><h2>${esc(t('adm_pf_auto'))}</h2><span class="desc">${esc(t('adm_pf_auto_hint'))}</span></div>
            <div class="card"><div class="card-body stack">
              <label class="switch"><input type="checkbox" id="pfEnabled"><span>${esc(t('adm_pf_enabled'))}</span></label>
              <div class="form-grid">
                <div class="field"><label for="pfScriptUrl">${esc(t('adm_pf_script_url'))}</label><input id="pfScriptUrl" class="mono"><div class="hint">${esc(t('adm_pf_script_url_hint'))}</div></div>
                <div class="field"><label for="pfScriptPath">${esc(t('adm_pf_script_path'))}</label><input id="pfScriptPath" class="mono"><div class="hint">${esc(t('adm_pf_script_path_hint'))}</div></div>
                <div class="field"><label for="pfLauncher">${esc(t('adm_pf_launcher'))}</label><input id="pfLauncher" class="mono"><div class="hint">${esc(t('adm_pf_launcher_hint'))}</div></div>
                <div class="field"><label for="pfGameName">${esc(t('adm_pf_game_name'))}</label><input id="pfGameName"><div class="hint">${esc(t('adm_pf_game_name_hint'))}</div></div>
                <div class="field"><label for="pfMaxClients">${esc(t('adm_pf_max_clients'))}</label><select id="pfMaxClients"><option value="1">1</option><option value="2">2</option></select><div class="hint">${esc(t('adm_pf_max_clients_hint'))}</div></div>
                <div class="field"><label for="pfWindow">${esc(t('adm_pf_window'))}</label><input id="pfWindow" type="number" min="0"><div class="hint">${esc(t('adm_pf_window_hint'))}</div></div>
                <div class="field"><label for="pfAttempts">${esc(t('adm_pf_attempts'))}</label><input id="pfAttempts" type="number" min="0"><div class="hint">${esc(t('adm_pf_attempts_hint'))}</div></div>
                <div class="field"><label for="pfCooldown">${esc(t('adm_pf_cooldown'))}</label><input id="pfCooldown" type="number" min="0"><div class="hint">${esc(t('adm_pf_cooldown_hint'))}</div></div>
              </div>
            </div></div>
          </section>
          <section class="section"><div class="section-head"><h2>${esc(t('adm_snap_title'))}</h2><span class="desc">${esc(t('adm_snap_desc'))}</span></div>
            <div class="card" id="pfSnaps"><div class="card-body"><div class="skeleton" style="height:48px"></div></div></div>
          </section>
        </div>
        <div class="pf-savebar">
          <span class="grow"><span class="muted small" id="pfDirty">${esc(t('adm_pf_no_changes'))}</span></span>
          <button class="btn ghost" id="pfReset" disabled>${esc(t('adm_pf_discard'))}</button>
          <button class="btn primary" id="pfSave" disabled>${esc(t('save'))}</button>
        </div>
      </div>`;

      const dirtyEl = App.$('#pfDirty', root), saveBtn = App.$('#pfSave', root), resetBtn = App.$('#pfReset', root);
      const v = (sel) => { const el = App.$(sel, root); return el ? el.value : ''; };
      const setV = (sel, val) => { const el = App.$(sel, root); if (el) el.value = val; };
      const chk = (sel) => { const el = App.$(sel, root); return el ? !!el.checked : false; };
      const setChk = (sel, on) => { const el = App.$(sel, root); if (el) el.checked = !!on; };
      const qaText = () => v('#pfQaConfig');
      const qaValid = () => { try { JSON.parse(qaText()); return true; } catch (_) { return false; } };
      const qaNorm = () => { try { return JSON.stringify(JSON.parse(qaText())); } catch (_) { return '\u0000invalid'; } };

      function currentFlat() {
        return {
          qa_image_sha256: imageSha,
          agent_url: v('#pfAgentUrl'), http_url: v('#pfHttpUrl'), game_image: v('#pfGameImage'), launch_command: v('#pfLaunchCmd'),
          qa_config: qaNorm(), enabled: String(chk('#pfEnabled')),
          script_url: v('#pfScriptUrl'), script_path: v('#pfScriptPath'),
          launcher_command: v('#pfLauncher'), game_name: v('#pfGameName'),
          max_clients: v('#pfMaxClients'), launch_window_seconds: v('#pfWindow'),
          max_attempts: v('#pfAttempts'), cooldown_seconds: v('#pfCooldown'),
          default_template_id: v('#pfDefaultTpl')
        };
      }
      const dirtyCount = () => { const c = currentFlat(); let n = 0; for (const k of Object.keys(c)) if (String(c[k]) !== String(orig[k])) n++; return n; };

      function renderImg() {
        App.$('#pfImgSha', root).textContent = imageSha ? shortSha(imageSha) : t('adm_pf_no_image');
        const im = images.find(x => x.sha256 === imageSha);
        App.$('#pfImgMeta', root).textContent = im ? ('· ' + t('adm_pf_uploaded', App.fmt.date(im.uploaded_at)) + ' · ' + fmtBytes(im.size)) : '';
        const pick = App.$('#pfPick', root); if (pick) pick.value = imageSha;
      }

      function updateDirty() {
        const n = dirtyCount(), ok = qaValid();
        dirtyEl.textContent = n ? t('adm_pf_dirty', n) : t('adm_pf_no_changes');
        saveBtn.disabled = n === 0 || !ok;
        resetBtn.disabled = n === 0;
        App.$('#pfQaField', root).classList.toggle('invalid', !ok);
        App.$('#pfQaErr', root).textContent = ok ? '' : t('adm_pf_json_invalid');
      }

      function applyPlatform(p) {
        platform = p || {};
        const al = platform.auto_launch || {};
        imageSha = platform.qa_image_sha256 || '';
        setV('#pfAgentUrl', platform.agent_url || ''); setV('#pfHttpUrl', platform.http_url || ''); setV('#pfGameImage', platform.game_image || ''); setV('#pfLaunchCmd', platform.launch_command || '');
        origPretty = JSON.stringify(platform.qa_config || {}, null, 2); setV('#pfQaConfig', origPretty);
        setChk('#pfEnabled', al.enabled);
        setV('#pfScriptUrl', al.script_url || ''); setV('#pfScriptPath', al.script_path || '');
        setV('#pfLauncher', al.launcher_command || ''); setV('#pfGameName', al.game_name || '');
        setV('#pfMaxClients', String(al.max_clients != null ? al.max_clients : 2));
        setV('#pfWindow', String(al.launch_window_seconds != null ? al.launch_window_seconds : 240));
        setV('#pfAttempts', String(al.max_attempts != null ? al.max_attempts : 3));
        setV('#pfCooldown', String(al.cooldown_seconds != null ? al.cooldown_seconds : 600));
        App.$('#pfPick', root).innerHTML = imageOptions();
        { const dt = App.$('#pfDefaultTpl', root); if (dt) { dt.innerHTML = defaultTplOptions(); dt.value = platform.default_template_id != null ? String(platform.default_template_id) : ''; } }
        renderImg();
        orig = currentFlat();
        updateDirty();
      }

      // upload a .dll -> register bytes, then select it (saved via the save bar)
      App.$('#pfFile', root).onchange = async (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        const btn = App.$('#pfUploadBtn', root), lbl = App.$('#pfUploadLabel', root);
        btn.classList.add('disabled'); btn.style.pointerEvents = 'none'; lbl.textContent = t('adm_pf_uploading');
        try {
          const buf = await file.arrayBuffer();
          const resp = await fetch('/api/ide/qa-images', { method: 'PUT', credentials: 'same-origin', headers: { 'Content-Type': 'application/octet-stream' }, body: buf });
          const data = await resp.json().catch(() => ({}));
          if (!resp.ok || !data.sha256) { App.toast(App.errorText(data) || t('adm_pf_upload_fail'), 'error'); return; }
          if (!images.some(im => im.sha256 === data.sha256)) images = [{ sha256: data.sha256, uploaded_at: Date.now(), size: file.size }, ...images];
          imageSha = data.sha256;
          App.$('#pfPick', root).innerHTML = imageOptions();
          renderImg(); updateDirty();
          App.toast(t('adm_pf_uploaded_ok'));
        } catch (_) { App.toast(t('adm_pf_upload_fail'), 'error'); }
        finally { btn.classList.remove('disabled'); btn.style.pointerEvents = ''; lbl.textContent = '⬆ ' + t('adm_pf_upload'); e.target.value = ''; }
      };
      App.$('#pfPick', root).onchange = (e) => { imageSha = e.target.value; renderImg(); updateDirty(); };
      App.$('#pfForm', root).addEventListener('input', updateDirty);
      App.$('#pfForm', root).addEventListener('change', updateDirty);

      resetBtn.onclick = () => { applyPlatform(platform); };
      saveBtn.onclick = async () => {
        if (!qaValid()) { App.toast(t('adm_pf_save_blocked'), 'error'); updateDirty(); return; }
        const body = {
          qa_image_sha256: imageSha,
          agent_url: v('#pfAgentUrl'), http_url: v('#pfHttpUrl'), game_image: v('#pfGameImage'), launch_command: v('#pfLaunchCmd'),
          qa_config: JSON.parse(qaText()),
          auto_launch: {
            enabled: chk('#pfEnabled'), script_url: v('#pfScriptUrl'), script_path: v('#pfScriptPath'),
            launcher_command: v('#pfLauncher'), game_name: v('#pfGameName'),
            max_clients: Number(v('#pfMaxClients')), launch_window_seconds: Number(v('#pfWindow')),
            max_attempts: Number(v('#pfAttempts')), cooldown_seconds: Number(v('#pfCooldown'))
          },
          default_template_id: v('#pfDefaultTpl') ? Number(v('#pfDefaultTpl')) : null
        };
        saveBtn.disabled = true; resetBtn.disabled = true;
        const res = await App.api('/api/admin/platform', { method: 'PUT', body });
        if (!res.ok) { App.toast(App.errorText(res.data), 'error'); updateDirty(); return; }
        applyPlatform(res.data.platform || body);
        App.toast(t('adm_pf_saved', res.data.synced != null ? res.data.synced : 0));
      };

      applyPlatform(platform);
      App.setLeaveGuard(() => dirtyCount() > 0);
      loadSnapshots(App.$('#pfSnaps', root));
      return () => App.setLeaveGuard(null);
    }
  });

  async function loadSnapshots(wrap) {
    const r = await App.api('/api/admin/schema-snapshots');
    if (!r.ok) { wrap.innerHTML = `<div class="card-body banner error">${esc(App.errorText(r.data))}</div>`; return; }
    const snaps = r.data.snapshots || [];
    if (!snaps.length) { wrap.innerHTML = `<div class="empty-state"><p>${esc(t('adm_snap_empty'))}</p></div>`; return; }
    wrap.innerHTML = `<div class="table-wrap"><table class="table">
      <thead><tr><th>${esc(t('adm_snap_version'))}</th><th>${esc(t('adm_snap_created'))}</th><th>${esc(t('adm_snap_size'))}</th><th></th></tr></thead>
      <tbody>${snaps.map(s => `<tr data-snap="${esc(s.id)}">
        <td><b>v${esc(s.from_version)} → v${esc(s.to_version)}</b></td>
        <td class="muted small">${esc(App.fmt.dateTime(s.created_at))}</td>
        <td class="muted small">${esc(fmtBytes(s.size))}</td>
        <td><div class="adm-actions-cell">
          ${s.bookmark ? `<button class="btn ghost sm" data-act="bm">${esc(t('adm_snap_copy_bookmark'))}</button>` : `<span class="muted small">${esc(t('adm_snap_no_bookmark'))}</span>`}
          <button class="btn secondary sm" data-act="dl">⬇ ${esc(t('adm_snap_download'))}</button>
        </div></td></tr>`).join('')}</tbody></table></div>`;
    App.$$('tr[data-snap]', wrap).forEach(tr => {
      const s = snaps.find(x => String(x.id) === tr.dataset.snap);
      const bm = tr.querySelector('[data-act=bm]'); if (bm) bm.onclick = () => App.copy(s.bookmark);
      tr.querySelector('[data-act=dl]').onclick = () => downloadSnapshot(s.id);
    });
  }

  async function downloadSnapshot(id) {
    const r = await App.api('/api/admin/schema-snapshots/' + id);
    if (!r.ok) { App.toast(App.errorText(r.data) || t('adm_snap_download_fail'), 'error'); return; }
    const blob = new Blob([JSON.stringify(r.data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'schema-snapshot-' + id + '.json';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    App.toast(t('adm_snap_downloaded'));
  }
})();
